<style lang="scss" scoped>
#sds-item-approval{
  background: rgb(245, 245, 245);
  min-height: calc(100vh - 63px);
}
.sds-status{
  border-radius: 5px;
  display: flex;
  height: 30px;
  padding:3px 7px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  color: rgb(251, 229, 229);
  border: 1px solid #cccccc;
  background-color: #cccccc;
  color: #424242;
  letter-spacing: .3px;
  
  &.submitted{
    border: 1px solid #00897B;
    background-color:#00897B;
    color: white;
  }

}
#form{
 transition: transform 1s;
}
.fade-leave-to{
  transition: opacity 0s;
}

.review-item{
  color: #424242;
  margin: 0 10px;
  display: flex;
  border-bottom: 1px solid rgb(216, 216, 216);

  &__number,&___note{
    padding: 5px;
  }
  &__number{
    width: 20px;
    padding: 5px;
  }
  &__field{
    font-weight: 600;
    // border-bottom: 1px dashed #006b61;
    color: #00897B;
  }
}
legend{font-size: 10px!important;}
.field{
  font-family: 'Manrope';
  font-weight: 500;
  color: #1f1f1f;
  position: relative;
  background: #FFF;
	border: 1px solid #e0e0e0;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  margin: 20px;
  &__form{
    padding: 20px 30px 7px 30px;
  }
  &__similarity{
    padding: 15px 25px 20px 25px;
    // background: #f5f5f5;
    background: #f2fffe;
    border-top:1px solid #dcedec;
  }
}

.item{
  padding: 10px 25px;
  position: relative;
  &__flag-error{
    padding: 0 4px 2px 4px;
    background: red;
    color: white;
    border-radius: 3px;
    letter-spacing: .5px;
    font-size: 11px;
    margin-bottom: 6px;
    margin-left: 4px;
  }
  &__info{
    padding: 10px 25px;
    display: flex;
    &__field-name{
      font-size: 12px;
      color: teal;
      font-weight:600;
    }
    &__field-value{
      // margin-top: -3px;
      font-size: 12px;        
    }
  }
  &__field-name{
    font-weight:600;
    font-size:15px;
    color: teal;
    display: flex;
    align-items: flex-end;
  }
  &__field-form{
    margin: 5px 0;
  }
  &__field-value{
    color: #1f1f1f;
    letter-spacing: .3px;
  }
  &__field-value__empty{
    border-bottom: 1px solid #d5d5d5;
    margin: 0 -25px -10px -25px; 
    padding: 0 25px 10px 25px;
  }
  &__similarity{
    background:#f2faff;
    border-top:1px solid lightgray;
    border-bottom:1px solid lightgray;
    padding: 10px 20px;
  }
  &__control{
    padding: 10px 25px;
    display: flex;
    align-items: stretch;
    
  }
  &__review{
    padding: 0px 25px 20px 25px;
    border-top: 1px solid #e2e2e2;
  }
}
.loading{
  background: #FFF;
	border: 1px solid #e0e0e0;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  margin: 20px;
  min-height: 75vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<template>
  <div id="sds-item-approval">
    <div class="page-control" style="padding-left:15px;padding-right:22px">
      <div class="page-control__left">
        <button class="button button--text button--action mr-2"  id="backUsulanList" @click="$router.back()">
            <VueFeather type="arrow-left" size="18" stroke-width="1.5" style="display:block"></VueFeather>
        </button>
        <b-popover target="backUsulanList" triggers="hover" placement="bottom">
          <template #title>Kembali ke halaman daftar usulan</template>
          Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik tombol draft atau submit, karena ketika kembali isian ada akan hilang
        </b-popover>
        <div>
          <div style="font-family:'Manrope';font-weight:600;font-size:16px;color:#032F05;">
          Pemeriksaan {{form.submission_type == 'NEW' ? 'Usulan Baru':'Pemutakhiran'}}&nbsp;<span class="text-primary" >{{form.sds_type == 'INDICATOR' ? 'Indikator' : (form.sds_type == 'VARIABLE' ? 'Variabel' : 'Konsep & Definisi')}}</span>
        </div>
        <div class="" style="font-family:'Manrope';font-weight:500;font-size:12px;color:#515151;">Harap baca panduan pemeriksaan terlebih dahulu sebelum melakukan pemeriksaan.</div>
        </div>
      </div>
      <div class="page-control__center">
      </div>
      <div class="page-control__right">
        <div class="d-flex ml-auto button-group mr-2">
          <button type="button" style="position:relative" class="button button--action button--action--delete" variant="outlined"  size="sm" @click="showSimilarSubmissionModal" v-b-popover.hover.bottom="'Lihat Usulan yang Mirip'" >
            <VueFeather type="layers" size="14" stroke-width="2.1" 
            :stroke="setting.similar_submission.items.filter(x=>x.sds_type == form.sds_type).length>0?'red':'#6c6c6c'"></VueFeather>
            <div 
              v-if="setting.similar_submission.items.filter(x=>x.sds_type == form.sds_type).length>0" 
              style="border-radius:15px;display:flex;align-items:center;justify-content:center;width:17px;height:17px;position:absolute;left:-9px; top:-6px; background:red;color:white;font-size:9px">
              {{setting.similar_submission.items.filter(x=>x.sds_type == form.sds_type).length}}</div>
          </button>
          <button type="button" class="button mr-2 button--action button--action--view" variant="outlined"  size="sm" @click="showUpdatingSubmissionTypeModal" v-b-popover.hover.bottom="'Ubah Jenis Usulan'" >
            <VueFeather type="send" size="14" stroke-width="2.1"></VueFeather>
          </button>
          <button type="button" class="button button--action mr-2 button--action--edit"  variant="outlined"  size="sm" @click="showUpdatingSdsTypeModal" v-b-popover.hover.bottom="'Ubah Jenis SDS'" >
            <VueFeather type="check-circle" size="14" stroke-width="2.1"></VueFeather>
          </button>
          
        </div>
        <button class="button mr-2" :class="reviewVisible ? 'active':''" variant="icon-outlined" size="sm" @click="reviewVisible = !reviewVisible">
          <VueFeather type="mail" size="16" stroke-width="2" style="display:block"></VueFeather></button>
        <button class="button" variant="primary" size="sm" @click="showSaveModal">
          <VueFeather type="check" size="15" stroke-width="2.5" style="display:block;"></VueFeather>&nbsp;&nbsp;Simpan
        </button>
      </div>
    </div>
    <b-row class="h-100p mx-0">
      <b-col id="form" class="form form--sm h-100p px-0">
        <ValidationObserver ref="conceptObserver" v-if="form.sds_type == 'CONCEPT' && concept">    
          <div id="con--name" class="field">
            <div class="field__form">
              <ValidationProvider name="Nama Konsep"  rules="required" v-slot="{errors}">
                <b-form-group label="Nama Konsep">
                  <b-form-input
                    v-model="concept.name" 
                    placeholder="Nama konsep"
                    :state="errors[0] ? false: (concept.name ? true : null)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && concept.updated_concept.items.filter(x=>x.name).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Konsep serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && concept.updated_concept.items.filter(x=>x.name).length>0">
                  <b-tr v-for="(item) in concept.updated_concept.items" :key="item.id">
                    <b-td>{{item.name}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(concept.name, item.name)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center text-nowrap">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.concept.name}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(concept.name, item.data.concept.name)}}</b-td>
                    <b-td class="text-left w-auto"> {{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="con--definition" class="field">
            <div class="field__form">
              <ValidationProvider name="Definsi Konsep"  rules="required" v-slot="{errors}">
                <b-form-group label="Definsi">
                  <b-form-textarea 
                    rows="3"
                    v-model="concept.definition" 
                    placeholder="Tuliskan secara jelas definisi konsep dan batasannya" 
                    :state="errors[0] ? false: (concept.definition ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && concept.updated_concept.items.filter(x=>x.definition).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Konsep serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && concept.updated_concept.items.filter(x=>x.name).length>0">
                  <b-tr v-for="(item) in concept.updated_concept.items" :key="item.id">
                    <b-td>{{item.definition}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(concept.definition, item.definition)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center text-nowrap">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.concept.definition}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(concept.definition, item.data.concept.definition)}}</b-td>
                    <b-td class="text-left w-auto"> {{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="con--references" class="field">
            <div class="field__form">
              <ValidationObserver ref="conceptReferencesObserver">
                <b-form-group label="Sumber referensi yang digunakan">
                  <b-table-simple class="table--form">
                    <b-tbody >
                      <b-tr v-for="(item,index) in concept.references" :key="index">
                        <b-td class="w-34">
                          <b-form-input :value="index+1" disabled style="text-align:center" class="p-0"></b-form-input>
                        </b-td>
                        <b-td>
                          <ValidationProvider :name="'Sumber referensi ke-'+(index+1)" rules="required" v-slot="{errors}">
                            <b-form-input 
                              type="search"
                              placeholder="Tuliskan sumber referensi dari konsep yang diusulkan"
                              v-model="concept.references[index]"
                              :state="errors[0] ? false: (item ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-td>
                        <td class="w-34">
                          <button 
                            class="button button--action button--action--sm button--danger"
                            v-on:click="deleteConceptReference(index)" 
                            :disabled="concept.references.length==1? true: false"
                          >
                            <VueFeather type="x" size="17"></VueFeather>
                          </button>
                        </td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                  <div class="d-flex justify-content-end border-top pt-2 mt-2">
                    <button class="button" variant="primary" size="sm" v-on:click="addConceptReference">
                      <VueFeather type="plus" size="16"></VueFeather>&nbsp; Tambah Referensi
                    </button>
                  </div>
                </b-form-group>
              </ValidationObserver>
            </div>
            <div class="field__similarity" v-if="isUpdate || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Konsep serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody >
                  <b-tr v-for="(item) in concept.updated_concept ? concept.updated_concept.items : []" :key="item.id" >
                    <b-td>
                      <div class="d-flex" v-for="(reference,index) in item.references" :key="index">
                        <div class="min-w-20" v-if="item.references.length>1">{{index+1}}.</div>
                        <div>{{reference ? reference : '-'}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{referencesSimilarity(concept.references, item.references)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center text-nowrap">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.concept.references" :key="index2">
                        <div class="min-w-20" v-if="item.data.concept.references.length>1">{{index2+1}}.</div>
                        <div>{{item2}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{referencesSimilarity(concept.references, item.data.concept.references)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
        </ValidationObserver>
        <ValidationObserver ref="variableObserver" v-else-if="form.sds_type == 'VARIABLE' && variable">
          <div id="var--name" class="field">
            <div class="field__form">
              <ValidationProvider name="Nama Variabel"  rules="required" v-slot="{errors}">
                <b-form-group label="Nama Variabel">
                  <b-form-input 
                    v-model="variable.name" 
                    placeholder="Nama Variabel"
                    :state="errors[0] ? false: (variable.name ? true : null)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.name).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Nama variabel serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.name).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td>{{item.name}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.name, item.name)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center text-nowrap">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.name}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.name, item.data.variable.name)}}</b-td>
                    <b-td class="text-left w-auto"> {{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--definition" class="field">
            <div class="field__form">
              <ValidationProvider name="Definsi Variabel"  rules="required" v-slot="{errors}">
                <b-form-group label="Definsi">
                  <b-form-textarea 
                    rows="3"
                    v-model="variable.definition" 
                    placeholder="Tuliskan secara jelas definisi variabel dan batasannya" 
                    :state="errors[0] ? false: (variable.definition ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.definition).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Definisi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.definition).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td>{{item.definition}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.definition, item.definition)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center text-nowrap">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.definition}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.definition, item.data.variable.definition)}}</b-td>
                    <b-td class="text-left w-auto"> {{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--concepts" class="field">
            <div class="field__form">
              <ValidationProvider name="Konsep variabel" rules="required" v-slot="{errors}">
                <b-form-group label="konsep">
                  <Treeselect 
                    placeholder="Pilih konsep yang digunakan"
                    clearable
                    valueFormat="object"
                    v-model="variableConcepts" 
                    :class="errors[0] ? 'invalid': (variableConcepts && variableConcepts.length>0 ? 'valid' : null)"
                    :multiple="true" 
                    :async="true"
                    :options="options.concept"
                    :loadOptions="conceptReferenceLoadOptions"
                    :normalizer="conceptNormalizer"
                    @input="variableConceptsChanged"
                  >
                  <div slot="option-label" slot-scope="{node}" class="border-bottom" style="padding: 10px 8px;">
                    <div class="d-flex align-items-start" >
                      <div class="mr-2">
                        <div style="color:#00897B;line-height: normal;font-weight:700">{{node.raw.name}}</div>
                        <div class="i-text-13 mt-1" style="color:#757575;line-height: normal;" >{{node.raw.definition}}</div>
                      </div>
                      <div class="ml-auto badge" :class="node.raw.source=='SDSN' ? 'badge--primary':'badge--secondary'">
                        {{node.raw.source.toLowerCase()}}
                      </div>
                    </div>
                  </div>
                  </Treeselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>

              <div class="table-wrapper mb-3">
                <b-table-simple class="table--light" >
                  <b-thead>
                    <tr>
                      <th class="text-center w-30">No</th>
                      <th class="text-left w-150">Nama</th>
                      <th class="text-left w-100">Definisi</th>
                      <th class="text-center w-80" colspan="2">Status</th>
                    </tr>
                  </b-thead>
                  <b-tbody >
                    <b-tr v-for="(item,index) in variableConcepts" :key="index">
                      <b-td class="text-center w-auto">{{index+1}}</b-td>
                      <b-td class="text-left">{{item.name}}</b-td>
                      <b-td class="text-left">{{item.definition}}</b-td>
                      <b-td class="text-center text-nowrap">
                        <div :class="'status status--'+statusFormatterStyle(item.status)" >
                          {{statusFormatter(item.status)}}
                        </div>
                      </b-td>
                      <b-td class="text-center w-auto" v-if="item.status == 'REJECTED'">
                        <b-button  type="button" class="button button--small button--text" >
                          <VueFeather type="repeat" size="16" stroke-width="2"></VueFeather>
                        </b-button>
                      </b-td>
                    </b-tr>
                    <b-tr v-if="variableConcepts.length==0">
                      <b-td class="text-danger text-center" colspan="6">
                        <div class="d-flex align-items-center justify-content-center py-1">
                          <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Tidak konsep yang digunakan
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.concepts.length>0).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Konsep serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.concepts.length>0).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td v-if="item.concepts.length>0">
                      <div class="d-flex" v-for="(concept,index) in item.concepts" :key="concept.id">
                        <div class="min-w-20" item.concepts.length>1>{{index+1}}.</div>
                        <div>{{concept.name}}</div>
                      </div>
                    </b-td>
                    <b-td v-if="item.concepts.length>0" class="text-center w-auto">{{conceptsSimilarity(variable.concepts, item.concepts)}}</b-td>
                    <b-td v-if="item.concepts.length>0" class="text-left w-auto">SDSN</b-td>
                    <b-td v-if="item.concepts.length>0" class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.variable.concepts" :key="index2">
                        <div class="min-w-20" v-if="item.data.variable.concepts.length>1">{{index2+1}}.</div>
                        <div>{{item2.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{conceptsSimilarity(variable.concepts, item.data.variable.concepts)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--unit_types" class="field">
            <div class="field__form">
              <ValidationProvider name="Unit Observasi" rules="required" v-slot="{errors}">
                <b-form-group label="Unit Observasi" description="Tuliskan unit observasi dimana variabel merupakan salah satu dari karakteristik unit observasi tersebut">
                  <multiselect 
                    tag-placeholder="Tambahkan unit observasi baru" 
                    placeholder="Pilih atau tambahkan unit observasi" 
                    selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                    label="name"  track-by="name" 
                    v-model="variable.unit_types" 
                    :options="options.unit_type" 
                    :multiple="true" 
                    :taggable="true" 
                    :class="errors[0] ? 'invalid': ( variable.unit_types.length>0 ? 'valid':'')"
                    @tag="addNewUnitType">
                    <template slot="option" slot-scope="props">
                      <input 
                        class="ml-2"
                        type="checkbox" 
                        :name="props.option.name ?  props.option.name: props.search" 
                        :checked="itemExist(props.option.name, variable.unit_types)">
                      <label for="vehicle3" class="pl-2 m-0 text-13">
                        {{ props.option.name ?  props.option.name: props.search  }}
                      </label>
                    </template>
                  </multiselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.unit_types.length>0).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Konsep serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.unit_types.length>0).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td v-if="item.unit_types.length>0">
                      <div class="d-flex" v-for="(concept,index) in item.unit_types" :key="concept.id">
                        <div class="min-w-20" item.concepts.length>1>{{index+1}}.</div>
                        <div>{{concept.name}}</div>
                      </div>
                    </b-td>
                    <b-td v-if="item.unit_types.length>0" class="text-center w-auto">{{unitTypesSimilarity(variable.unit_types, item.unit_types)}}</b-td>
                    <b-td v-if="item.unit_types.length>0" class="text-left w-auto">SDSN</b-td>
                    <b-td v-if="item.unit_types.length>0" class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.variable.unit_types" :key="index2">
                        <div class="min-w-20" v-if="item.data.variable.unit_types.length>1">{{index2+1}}.</div>
                        <div>{{item2.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{unitTypesSimilarity(variable.unit_types, item.data.variable.unit_types)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--measurement" class="field">
            <div class="field__form">
              <ValidationProvider name="Ukuran Variabel"  v-slot="{errors}">
                <b-form-group label="Ukuran" description="Kosongkan jika tidak ada">
                  <multiselect 
                    tag-placeholder="Tambahkan ukuran baru" 
                    placeholder="Pilih atau tambahkan ukuran" 
                    selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                    label="name"  track-by="name" 
                    v-model="variable.measurement" 
                    :options="measurements" 
                    :taggable="true" 
                    :class="errors[0] ? 'invalid': ( variable.measurement ? 'valid':'')"
                    @input="variable.measurement_unit = null"
                    @tag="addNewVariableMeasurement">
                  </multiselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="variable.measurement && (similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.measurement).length>0))">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Ukuran serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.measurement).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td>{{item.measurement ? item.measurement.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.measurement.name, item.measurement ? item.measurement.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.measurement ? item.data.variable.measurement.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.measurement.name, item.data.variable.measurement ? item.data.variable.measurement.name : null)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_namee}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--measurement_unit" class="field">
            <div class="field__form">
              <ValidationProvider name="Satuan Variabel" :rules="variable.measurement ? 'required':''" v-slot="{errors}">
                <b-form-group label="Satuan" description="Kosongkan jika tidak ada ukuran variabel">
                  <multiselect 
                    tag-placeholder="Tambahkan satuan baru untuk ukuran yang digunakan" 
                    placeholder="Pilih atau tambahkan satuan" 
                    selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                    label="name"  track-by="name" 
                    v-model="variable.measurement_unit" 
                    :options="variableMeasurementUnits" 
                    :taggable="true" 
                    :class="errors[0] ? 'invalid': ( variable.measurement_unit ? 'valid':'')"
                    @tag="addNewVariableMeasurementUnit">
                  </multiselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="variable.measurement_unit && (similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.measurement_unit).length>0))">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Satuan serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.measurement_unit).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td>{{item.measurement_unit ? item.measurement_unit.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.measurement_unit.name, item.measurement_unit ? item.measurement_unit.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.measurement_unit ? item.data.variable.measurement_unit.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.measurement_unit.name, item.data.variable.measurement_unit ? item.data.variable.measurement_unit.name : null)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_namee}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--subject" class="field">
            <div class="field__form">
              <ValidationProvider name="Subyek variabel" rules="required" v-slot="{errors}">
                <b-form-group ref="subyekVariable" label="Subyek" description="Pilih subyek yang cocok dengan variabel">
                  <Treeselect 
                    clearable
                    valueFormat="object"
                    placeholder="Pilih subyek"
                    v-model="variable.subject_field"
                    :disable-branch-nodes="true"
                    :normalizer="normalizer"
                    :class="errors[0] ? 'invalid': (variable.subject_field ? 'valid' : null)"
                    :options="options.subject_fields"
                    :loadOptions="loadOptions"
                  >
                    <div slot="option-label" slot-scope="{node}" class="d-flex">
                      <div :style="node.raw.code.length==1 ? 'width:20px':(node.raw.code.length<=4 ? 'width:32px':'width:45px' )">{{node.raw.code}}.</div>
                      <div>{{node.raw.name}}</div>
                    </div>
                  </Treeselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.subject_field).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Subyek serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.subject_field).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td>{{item.subject_field ? item.subject_field.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.subject_field.name, item.subject_field ? item.subject_field.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.subject_field ? item.data.variable.subject_field.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.subject_field.name, item.data.variable.subject_field ? item.data.variable.subject_field.name : null)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--value_domain_type" class="field">
            <div class="field__form">
              <ValidationProvider name="Jenis Value Domain"  rules="required" v-slot="{errors}">
                <b-form-group label="Jenis Value Domain" description="">
                  <b-form-radio-group 
                    v-model="variable.value_domain.type" 
                    :state="errors[0] ? false: (variable.value_domain.type? true : null)"
                    :options="options.value_domain_type"
                    :class="errors ? 'invalid':'valid'"
                    @input="valueDomainTypeChanged"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.value_domain.type).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Jenis value domain serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && variable.updated_variable.items.filter(x=>x.value_domain.type).length>0">
                  <b-tr v-for="(item) in variable.updated_variable.items" :key="item.id">
                    <b-td>{{item.value_domain.type ? (item.value_domain.type.id == 75 ? 'Non Kategori':'Kategori') : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.value_domain.type.name, item.value_domain.type ? item.value_domain.type.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.value_domain.type ? (item.data.variable.value_domain.type.id == 75 ? 'Non Kategori':'Kategori') : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.value_domain.type.name, item.data.variable.value_domain.type.name)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--value_domain_items" class="field" v-if="variable.value_domain.type && variable.value_domain.type.id==76 ">
            <div class="field__form">
              <div class="bg-white" style="margin:-20px -30.5px 0px -30.5px">
                <div class="border-bottom px-4 py-3" style="background:#f3f3f3;">
                  <div class="text-13 text-bold border-bottom pb-1">Value domain (Klasifikasi)</div>
                  <div class="text-12 pt-1">
                    Value domain adalah rentang nilai dari isian variabel yang diperboleh. 
                    Isian value domain yang terlalu banyak seperti kode master wilayah atau KBLI tidak perlu
                    diisikan itemnya satu persatu. <span class="text-danger">Contoh: Jika Variabelnya adalah jenis kelamin maka item value domainnya 
                    adalah (1). Laki-laki dan (2). Perempuan </span>
                  </div>
                </div>
                <div style="padding:20px 30px 5px 30px">
                  <b-form-group label="Pilih Klasifikasi yang digunakan sebagai referensi value domain">
                    <b-form-radio-group stacked
                      v-model="classificationReferenceId"
                      :options="options.classification_series"
                      @input="(value)=>{
                        variable.value_domain.items=[];
                        if(value){
                          let classSeries = this.options.classification_series.find(x=>x.id == value);
                          variable.value_domain.classification_reference.id = classSeries.id;
                          variable.value_domain.classification_reference.name = classSeries.name;
                          variable.value_domain.classification_reference.description = classSeries.description;
                          classificationReferenceUsedType= 'FULL'
                        }else{
                          variable.value_domain.classification_reference = null;
                          variable.value_domain.items.push({
                            id: null,
                            code: null,
                            name: null,
                            description: null,
                            parent_code: null,
                            level: null,
                          });
                        }  
                      }"
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-group label="Jenis penggunaan item klasifikasi" v-if="classificationReferenceId">
                    <b-form-radio-group stacked
                      v-model="classificationReferenceUsedType"
                      @input="(value)=>{
                        variable.value_domain.classification_reference.used_type = value;
                        variable.value_domain.items=[];
                      }"
                    >
                      <b-form-radio value="FULL">Semua kode digunakan</b-form-radio>
                      <b-form-radio value="PARTIAL">Hanya sebagian kode yang digunakan</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <!-- {{variable.value_domain.classification_reference.used_type=='PARTIAL'}} -->
                <div class="px-4 pt-3 border-top" v-if="variable.value_domain.type && variable.value_domain.type.id==76 && (classificationReferenceId ==null || (classificationReferenceId && classificationReferenceUsedType=='PARTIAL'))">
                  <ValidationObserver ref="valueDomainItemsObserver">
                    <b-form-group label="Daftar item value domain">
                      <b-table-simple class="table--light" :class="classificationReferenceId !=null && classificationReferenceUsedType=='PARTIAL' ? '' : 'table--form'">
                        <b-thead>
                          <tr>
                            <th class="text-center w-40">No</th>
                            <th class="text-left w-150">Kode</th>
                            <th class="text-left">Nama</th>
                            <th class="text-left" colspan="2">Deskripsi</th>
                          </tr>
                        </b-thead>
                        <b-tbody v-if="classificationReferenceId == null">
                          <b-tr v-for="(item,index) in variable.value_domain.items" :key="index">
                            <b-td class="w-34">
                              <b-form-input :value="index+1" disabled style="text-align:center" size="sm" class="p-0"></b-form-input>
                            </b-td>
                            <b-td>
                              <ValidationProvider :name="'Kode Item ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                <b-form-input 
                                  size="sm"
                                  :state="errors[0] ? false: (item.code ? true : null)"
                                  v-model="item.code" 
                                  placeholder="Contoh : L , P" ></b-form-input>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </ValidationProvider>
                            </b-td>
                            <b-td>
                              <ValidationProvider :name="'Nama Item ke-'+(index+1)" rules="required" v-slot="{errors}">
                                  <b-form-input 
                                    size="sm"
                                    :state="errors[0] ? false: (item.name ? true : null)"
                                    v-model="item.name" 
                                    placeholder="Contoh : Laki-laki , Perempuan" ></b-form-input>
                                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </b-td>
                            <b-td>
                              <b-form-input  
                                size="sm" 
                                v-model="item.description"  
                                placeholder="Contoh : Laki-laki adalah ..." >
                              </b-form-input>   
                            </b-td>
                            <td class="w-34">
                              <b-button 
                                class="button button--action button--action--sm button--danger" 
                                v-on:click="deleteVariableValueDomain(index)" 
                                :disabled="variable.value_domain.items.length==1"
                              >
                                <VueFeather type="x" size="17"></VueFeather>
                              </b-button>
                            </td>
                          </b-tr>
                        </b-tbody>

                        <b-tbody v-if="classificationReferenceUsedType=='PARTIAL'">
                          <b-tr v-for="(item,index) in variable.value_domain.items" :key="index">
                            <b-td class="text-center">{{index+1}}</b-td>
                            <b-td>{{item.code}}</b-td>
                            <b-td>{{item.name}}</b-td>
                            <b-td>{{item.description}}</b-td>
                            <td class="w-34">
                              <div class="d-flex justify-content-center">
                                <b-button 
                                  class="button button--action button--action--delete"
                                  v-on:click="deleteVariableValueDomain(index)" 
                                  :disabled="variable.value_domain.items.length==1"
                                >
                                  <VueFeather type="trash" size="16"></VueFeather>
                                </b-button>
                              </div>
                            </td>
                          </b-tr>
                          <b-tr v-if="variable.value_domain.items.length==0">
                            <b-td class="text-danger text-center" colspan="6">
                              <div class="d-flex align-items-center justify-content-center py-1">
                                <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Item Value Domain tidak boleh kosong
                              </div>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-form-group>
                  </ValidationObserver>
                </div>
                <div class="d-flex justify-content-end mx-4 py-2 border-top" v-if="classificationReferenceId==null">
                  <b-button class="button button--secondary" 
                    v-on:click="addNewVariableValueDomain" >Tambah item
                  </b-button>
                </div>
                <div class="d-flex justify-content-end mx-4 py-2 border-top" 
                  v-if="classificationReferenceId !=null && classificationReferenceUsedType=='PARTIAL'"
                >
                  <b-button class="button button--secondary" 
                    v-on:click="showModalValueDomain(classificationReferenceId)" >Tambah item
                  </b-button>
                </div>
              </div>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.value_domain.items.length>0).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th colspan="7" class="text-left">Item value domain serupa</th>
                  </tr>
                  <tr>
                    <th class="text-center w-45">Kode</th>
                    <th class="text-left w-150">Nama</th>
                    <th class="text-left min-w-101 px-2">Deskripsi</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170"  >Produsen Data</th>
                    <th class="text-center w-80" >Status</th>
                    
                  </tr>
                </b-thead>
                <b-tbody v-for="(item) in variable.updated_variable ? variable.updated_variable.items : []" :key="item.id">
                  <b-tr v-for="(item2,index2) in item.value_domain.items" :key="index2">
                    <b-td class="border-0 text-center">{{item2.code ? item2.code : '-'}}</b-td>
                    <b-td class="border-0">{{item2.name}}</b-td>
                    <b-td class="border-0">{{item2.description ? item2.description : '-'}}</b-td>
                    <b-td v-if="index2==0" :rowspan="item.value_domain.items.length" class="text-center w-auto">{{valueDomainItemSimilarity(variable.value_domain.items, item.value_domain.items)}}</b-td>
                    <b-td v-if="index2==0" :rowspan="item.value_domain.items.length" class="text-left w-auto"  >SDSN</b-td>
                    <b-td v-if="index2==0" :rowspan="item.value_domain.items.length" class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody v-for="(item) in similarSdsItems" :key="item.id">
                  <b-tr v-for="(item2,index2) in item.data.variable.value_domain.items" :key="index2">
                    
                    <b-td class="border-0 text-center">{{item2.code ? item2.code : '-'}}</b-td>
                    <b-td class="border-0">{{item2.name}}</b-td>
                    <b-td class="border-0">{{item2.description ? item2.description : '-'}}</b-td>
                    <b-td v-if="index2==0" :rowspan="item.data.variable.value_domain.items.length"  class="text-center w-auto">{{valueDomainItemSimilarity(variable.value_domain.items, item.data.variable.value_domain.items)}}</b-td>
                    <b-td v-if="index2==0" :rowspan="item.data.variable.value_domain.items.length" class="text-left w-auto"   >{{item.produsen_data_name}}</b-td>
                    <b-td v-if="index2==0" :rowspan="item.data.variable.value_domain.items.length" class="text-center text-nowrap" >
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="var--rule" class="field">
            <div class="field__form">
              <ValidationProvider name="Aturan Validasi" v-slot="{errors}">
                <b-form-group label="Aturan Validasi">
                  <b-form-textarea 
                    rows="3"
                    v-model="variable.rule" 
                    placeholder="Deskripsikan aturan validasi yang dimiliki variabel" 
                    :state="errors[0] ? false: (variable.rule ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.rule != null).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Aturan validasi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen DAta</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody >
                  <b-tr v-for="(item) in variable.updated_variable ? variable.updated_variable.items : []" :key="item.id" >
                    <b-td>{{item.rule ? item.rule : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.rule, item.rule)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.variable.rule ? item.data.variable.rule : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(variable.rule, item.data.variable.rule)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>         
          <div id="var--references" class="field">
            <div class="field__form">
              <ValidationObserver ref="variableReferencesObserver">
                <b-form-group label="Sumber referensi yang digunakan">
                  <b-table-simple class="table--form">
                    <b-tbody >
                      <b-tr v-for="(item,index) in variable.references" :key="index">
                        <b-td class="w-34">
                          <b-form-input :value="index+1" disabled style="text-align:center" size="sm" class="p-0"></b-form-input>
                        </b-td>
                        <b-td>
                          <ValidationProvider :name="'Sumber referensi ke-'+(index+1)" rules="required" v-slot="{errors}">
                            <b-form-input 
                              type="search"
                              placeholder="Tuliskan sumber referensi dari variabel yang diusulkan"
                              v-model="variable.references[index]"
                              :state="errors[0] ? false: (item ? true : null)"
                              size="sm"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-td>
                        <td class="w-34">
                          <b-button 
                            class="button button--action button--action--sm button--danger" 
                            v-on:click="deleteVariableReference(index)" 
                            :disabled="variable.references.length==1? true: false"
                          >
                            <VueFeather type="x" size="17"></VueFeather>
                          </b-button>
                        </td>
                      </b-tr>
                      <tr>
                        <td class="my-0"></td>
                        <td class="my-0">
                          <div class="d-flex justify-content-end">
                            <b-button class="button button--secondary" 
                              v-on:click="addVariableReference" >Tambah Referensi</b-button>
                          </div>
                        </td>
                        <td class="my-0"></td>
                      </tr>
                    </b-tbody>
                  </b-table-simple>
                </b-form-group>
              </ValidationObserver>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && variable.updated_variable.items.filter(x=>x.references.length>0).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Referensi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(item) in variable.updated_variable ? variable.updated_variable.items : []" :key="item.id" >
                    <b-td>
                      <div class="d-flex" v-for="(reference,index) in item.references" :key="index">
                        <div class="min-w-20" v-if="item.references.length>1">{{index+1}}.</div>
                        <div>{{reference ? reference : '-'}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{referencesSimilarity(variable.references, item.references)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.variable.references" :key="index2">
                        <div class="min-w-20" v-if="item.data.variable.references.length>1">{{index2+1}}.</div>
                        <div>{{item2}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{referencesSimilarity(variable.references, item.data.variable.references)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
        </ValidationObserver>
        
        <ValidationObserver ref="indicatorObserver" v-else-if="form.sds_type == 'INDICATOR' && indicator">
          <div id="ind--name" class="field">
            <div class="field__form">
              <ValidationProvider name="Nama Indikator"  rules="required" v-slot="{errors}">
                <b-form-group label="Nama Indikator">
                  <b-form-input 
                    v-model="indicator.name" 
                    placeholder="Nama Indikator"
                    :state="errors[0] ? false: (indicator.name ? true : null)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Nama serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="(isUpdate && indicator.updated_indicator.items.length>0)">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.name}}</b-td>
                    <b-td class="text-center">{{similarity(indicator.name, item.name)}}</b-td>
                    <b-td>SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.name}}</b-td>
                    <b-td class="text-center">{{similarity(indicator.name, item.data.indicator.name)}}</b-td>
                    <b-td>{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="ind--definition" class="field">
            <div class="field__form">
              <ValidationProvider name="Definsi Indikator"  rules="required" v-slot="{errors}">
                <b-form-group label="Definsi">
                  <b-form-textarea 
                    rows="3"
                    v-model="indicator.definition" 
                    placeholder="Tuliskan secara jelas definisi Indikator dan batasannya" 
                    :state="errors[0] ? false: (indicator.definition ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.definition).length>0)|| similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Definisi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.definition).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.definition}}</b-td>
                    <b-td class="text-center">{{similarity(indicator.definition, item.definition)}}</b-td>
                    <b-td>SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.definition}}</b-td>
                    <b-td class="text-center">{{similarity(indicator.definition, item.data.indicator.definition)}}</b-td>
                    <b-td>{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>         
          <div id="ind--concepts" class="field">
            <div class="field__form">
              <ValidationProvider name="Konsep indikator" rules="required" v-slot="{errors}">
                <b-form-group label="konsep">
                  <Treeselect 
                    placeholder="Pilih konsep yang digunakan"
                    clearable
                    valueFormat="object"
                    v-model="indicatorConcepts" 
                    :class="errors[0] ? 'invalid': (indicatorConcepts.length>0 ? 'valid' : null)"
                    :async="true"
                    :multiple="true" 
                    :options="options.concept"
                    :loadOptions="conceptReferenceLoadOptions"
                    :normalizer="conceptNormalizer"
                    @input="indicatorConceptsChanged"
                  >
                  <div slot="option-label" slot-scope="{node}" class="border-bottom" style="padding: 10px 8px;">
                    <div class="d-flex align-items-center" >
                      <div class="mr-2">
                        <div style="color:#00897B;line-height: normal;font-weight:700">{{node.raw.name}}</div>
                        <div class="i-text-13 mt-1" style="color:#757575;line-height: normal;" >{{node.raw.definition}}</div>
                      </div>
                      <div class="ml-auto badge" :class="node.raw.source=='SDSN' ? 'badge--primary':'badge--secondary'">{{node.raw.source.toLowerCase()}}</div>
                    </div>
                  </div>
                  </Treeselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
              
              <div class="table-wrapper mb-3 pb-1">
                <b-table-simple class="table--light" >
                  <b-thead>
                    <tr>
                      <th class="text-center w-30">No</th>
                      <th class="text-left w-150">Nama</th>
                      <th class="text-left">Definisi</th>
                      <th class="text-center w-80">Status</th>
                      <th class="text-center w-auto"></th>
                    </tr>
                  </b-thead>
                  <b-tbody >
                    <b-tr v-for="(item,index) in indicatorConcepts" :key="index">
                      <b-td class="text-center w-auto">{{index+1}}</b-td>
                      <b-td class="text-left">{{item.name}}</b-td>
                      <b-td class="text-left">{{item.definition}}</b-td>
                      <b-td class="text-center w-auto text-nowrap">
                        <div :class="'status status--'+statusFormatterStyle(item.status)" >
                          {{statusFormatter(item.status)}}
                        </div>
                      </b-td>
                      <b-td class="text-center w-auto">
                        <b-button v-if="item.status == 'REJECTED'" type="button" class="button button--small button--text"  >
                          <VueFeather type="repeat" size="16" stroke-width="2"></VueFeather>
                        </b-button>
                        <!-- <b-button v-else type="button" class="button button--small button--text" @click="showConceptReferenceDetail(item)" >
                          <VueFeather type="eye" size="16" stroke-width="2" ></VueFeather>
                        </b-button> -->
                      </b-td>
                    </b-tr>
                    <b-tr v-if="indicatorConcepts.length==0">
                      <b-td class="text-danger text-center" colspan="6">
                        <div class="d-flex align-items-center justify-content-center py-1">
                          <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Tidak konsep yang digunakan
                        </div>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.concepts.length>0).length>0) || similarSdsItems.filter(x=>x.data.indicator.concepts.length>0).length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Konsep serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.concepts.length>0).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>
                      <div class="d-flex" v-for="(concept,index) in item.concepts" :key="index">
                        <div class="min-w-20">{{index+1}}.</div>
                        <div>{{concept.name ? concept.name : '-'}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center">{{referencesSimilarity(indicator.concepts, item.concepts)}}</b-td>
                    <b-td>SDSN</b-td>
                    <b-td>
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody v-if="similarSdsItems.filter(x=>x.data.indicator.concepts.length>0).length>0">
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.indicator.concepts" :key="index2">
                        <div class="min-w-20">{{index2+1}}.</div>
                        <div>{{item2.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center">{{referencesSimilarity(indicator.concepts, item.data.indicator.concepts)}}</b-td>
                    <b-td>{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="ind--measurement" class="field">
            <div class="field__form">
              <ValidationProvider name="Ukuran Indikator" rules="required" v-slot="{errors}">
                <b-form-group label="Ukuran">
                  <multiselect 
                    tag-placeholder="Tambahkan ukuran baru" 
                    placeholder="Pilih atau tambahkan ukuran" 
                    selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                    label="name"  track-by="name" 
                    v-model="indicator.measurement" 
                    :options="measurements" 
                    :taggable="true" 
                    :class="errors[0] ? 'invalid': ( indicator.measurement ? 'valid':'')"
                    @input="indicator.measurement_unit = null"
                    @tag="addNewIndicatorMeasurement">
                  </multiselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.measurement).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Ukuran serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.measurement).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.measurement ? item.measurement.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.measurement ? indicator.measurement.name : null, item.measurement ? item.measurement.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-101">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.measurement ? item.data.indicator.measurement.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.measurement ? indicator.measurement.name : null, item.data.indicator.measurement ? item.data.indicator.measurement.name : null)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="ind--measurement_unit" class="field">
            <div class="field__form">
              <ValidationProvider name="Satuan Indikator" rules="required" v-slot="{errors}">
                <b-form-group label="Satuan">
                  <multiselect 
                    tag-placeholder="Tambahkan satuan baru untuk ukuran yang digunakan" 
                    placeholder="Pilih atau tambahkan satuan" 
                    selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                    label="name"  track-by="name" 
                    v-model="indicator.measurement_unit" 
                    :options="indicatorMeasurementUnits" 
                    :taggable="true" 
                    :class="errors[0] ? 'invalid': ( indicator.measurement_unit ? 'valid':'')"
                    @tag="addNewIndicatorMeasurementUnit">
                  </multiselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && indicator.updated_indicator.items.filter(x=>x.measurement_unit).length>0) ">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Satuan serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.measurement_unit).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.measurement_unit ? item.measurement_unit.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.measurement_unit ? indicator.measurement_unit.name : null, item.measurement_unit ? item.measurement_unit.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.measurement_unit ? item.data.indicator.measurement_unit.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.measurement_unit ? indicator.measurement_unit.name : null, item.data.indicator.measurement_unit ? item.data.indicator.measurement_unit.name : null)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="ind--subject" class="field">
            <div class="field__form">
               <ValidationProvider name="Subyek Indikator" rules="required" v-slot="{errors}">
                <b-form-group label="Subyek" description="Pilih subyek yang cocok dengan Indikator">
                  <Treeselect 
                    clearable
                    valueFormat="object"
                    placeholder="Pilih subyek"
                    v-model="indicator.subject_field"
                    :disable-branch-nodes="true"
                    :normalizer="normalizer"
                    :class="errors[0] ? 'invalid': (indicator.subject_field ? 'valid' : null)"
                    :options="options.subject_fields"
                    :loadOptions="loadOptions"
                  >
                    <div slot="option-label" slot-scope="{node}" class="d-flex">
                      <div :style="node.raw.code.length==1 ? 'width:20px':(node.raw.code.length<=4 ? 'width:32px':'width:45px' )">{{node.raw.code}}.</div>
                      <div>{{node.raw.name}}</div>
                    </div>
                  </Treeselect>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="similarSdsItems.length>0 || (isUpdate && indicator.updated_indicator.items.filter(x=>x.subject_field).length>0)">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Subyek serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.subject_field).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.subject_field ? item.subject_field.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.subject_field ? indicator.subject_field.name : null, item.subject_field ? item.subject_field.name : null)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.subject_field ? item.data.indicator.subject_field.name : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.subject_field.name, item.data.indicator.subject_field ? item.data.indicator.subject_field.name : null)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>         
          <div id="ind--benefit" class="field">
            <div class="field__form">
              <ValidationProvider name="Manfaat Indikator" rules="required" v-slot="{errors}">
                <b-form-group label="Manfaat">
                  <b-form-textarea 
                    rows="3"
                    v-model="indicator.benefit" 
                    placeholder="Manfaat Indikator" 
                    :state="errors[0] ? false: (indicator.benefit ? true : null)"
                  ></b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x => x.benefit).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Manfaat serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x => x.benefit).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.benefit ? item.benefit : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.benefit, item.benefit)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.benefit}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.benefit, item.data.indicator.benefit)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>          
          <div id="ind--interpretation" class="field">
            <div class="field__form">
              <ValidationProvider name="Interpretasi Indikator" rules="required" v-slot="{errors}">
                <b-form-group label="Interpretasi">
                  <b-form-textarea 
                    rows="3"
                    v-model="indicator.interpretation" 
                    placeholder="Interpretasi Indikator" 
                    :state="errors[0] ? false: (indicator.interpretation ? true : null)"
                  ></b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity"  v-if="(isUpdate && indicator.updated_indicator.items.filter(x => x.interpretation).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Interpretasi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x => x.interpretation).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.interpretation ? item.interpretation :'-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.interpretation, item.interpretation)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.interpretation}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.interpretation, item.data.indicator.interpretation)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>          
          <div id="ind--presentation_levels" class="field">
            <div class="field__form">
              <ValidationProvider name="Level terkecil tersedianya data Indikator"  rules="required" v-slot="{errors}">
                <b-form-group label="Level terkecil tersedianya data" description="">
                  <b-form-checkbox-group
                    v-model="indicator.presentation_levels"
                    :state="errors[0] ? false: (indicator.presentation_levels ? true : null)"
                    :options="options.presentation_level"
                    @change="indicatorPresentationLevelChanged"
                  ></b-form-checkbox-group>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.presentation_levels.length>0).length>0) || similarSdsItems.length>0 ">
               <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Level terkecil tersedianya data yang serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.presentation_levels.length>0).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>
                      <div class="d-flex" v-for="(level,index) in item.presentation_levels" :key="index">
                        <div class="min-w-20">-</div>
                        <div>{{level.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{levelsSimilarity(indicator.presentation_levels, item.presentation_levels)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.indicator.presentation_levels" :key="index2">
                        <div class="min-w-20">-</div>
                        <div>{{item2.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{levelsSimilarity(indicator.presentation_levels, item.data.indicator.presentation_levels)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>         
          <div id="ind--calculation_mechanism" class="field">
            <div class="field__form">
              <ValidationProvider name="Mekanisme Perhitungan" rules="required" v-slot="{errors}">
                <b-form-group label="Mekanisme Perhitungan Indikator">
                  <b-form-textarea 
                    rows="3"
                    v-model="indicator.calculation_mechanism" 
                    placeholder="Mekanisme Perhitungan Indikator" 
                    :state="errors[0] ? false: (indicator.calculation_mechanism ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.calculation_mechanism).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Mekanisme Perhitungan serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.calculation_mechanism).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>{{item.calculation_mechanism ? item.calculation_mechanism : '-'}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.calculation_mechanism, item.calculation_mechanism)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>{{item.data.indicator.calculation_mechanism}}</b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.calculation_mechanism, item.data.indicator.calculation_mechanism)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>         
          <div id="ind--formula" class="field">
            <div class="field__form">
              <ValidationProvider name="Rumus"  rules="required" v-slot="{errors}">
                <b-form-group label="Rumus" description="Jika tidak ada ukuran, isikan '-'">
                  <EquationEditor id="formula" :value.sync="indicator.formula" size="xl"></EquationEditor>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>

              <div class="py-3 border-top">
                <ValidationObserver ref="formulaStructuresObserver">
                  <b-form-group label="Keterangan rumus">
                    <b-table-simple class="table--light table--form">
                      <b-thead>
                        <tr>
                          <th class="text-center w-40">No</th>
                          <th class="text-left w-150 max-w-150">Simbol</th>
                          <th class="text-left pr-0" colspan="2">Deskripsi</th>
                        </tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(item,index) in indicator.formula_structures" :key="index">
                          <b-td>
                            <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                          </b-td>
                          <b-td>
                            <ValidationProvider name="Simbol"  rules="required" v-slot="{errors}">
                              <b-form-group>
                                <EquationEditor :value.sync="item.symbol" size="sm"></EquationEditor>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-td>
                          <b-td class="pr-0">
                            <ValidationProvider name="Deskripsi Simbol"  rules="required" v-slot="{errors}">
                              <b-form-group>
                                <b-form-input 
                                  :state="errors[0] ? false: (item ? true : null)"
                                  v-model="item.description" size="sm"
                                  placeholder="Wilayah, Jenis Kelamin, dan lainnya" ></b-form-input>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                              </b-form-group>
                            </ValidationProvider>
                          </b-td>
                          <td class="w-34 pl-0">
                            <b-button class="button button--action button--action--sm button--danger" 
                              v-on:click="deleteFormulaStructure(index)" >
                              <VueFeather type="x" size="17"></VueFeather>
                            </b-button>
                          </td>
                        </b-tr>
                        <b-tr v-if="indicator.formula_structures.length==0">
                          <b-td class="text-danger text-center" colspan="6">
                            <div class="d-flex align-items-center justify-content-center py-1">
                              <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Belum ada keterangan rumus yang diinput
                            </div>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <div class="d-flex justify-content-end border-top pt-2">
                      
                      <button class="button" size="sm" variant="primary" v-on:click="addFormulaStructure" >
                        <VueFeather type="plus" size="14" stroke-width="2"></VueFeather> &nbsp; Tambah Keterangan
                      </button>
                    </div>
                  </b-form-group>
                </ValidationObserver>
              </div>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.formula).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Rumus serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.formula).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>
                      <div class="pt-2">
                        <EquationViewer :value="item.formula ? item.formula : '-'"></EquationViewer>
                        <div class="mt-4 equation-structure" v-if="item.formula">
                          <div class="item__field-name">Keterangan Rumus</div>
                          <b-table-simple class="table--outlined">
                            <b-tbody>
                              <b-tr v-for="(structure,structureIndex) in item.formula_structures" :key="structureIndex" :class="index!=0? 'border-top':''" style="border-color:#e9e9e9 !important">
                                <b-td :style="structure.symbol && structure.symbol.length<6 ? 'width:80px ':'white-space:nowrap'">
                                  <EquationViewer :value="structure.symbol? structure.symbol : '-'"></EquationViewer>
                                </b-td>
                                <b-td style="vertical-align:middle">
                                  {{structure.description}}
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.formula, item.formula)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-left w-auto">-</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >                          
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="pt-2">
                        <EquationViewer :value="item.data.indicator.formula ? item.data.indicator.formula : '-'"></EquationViewer>
                        <div class="mt-4 equation-structure" v-if="item.data.indicator.formula">
                          <div class="item__field-name">Keterangan Rumus</div>
                          <b-table-simple class="table--outlined">
                            <b-tbody>
                              <b-tr v-for="(item,index) in item.data.indicator.formula_structures" :key="index" :class="index!=0? 'border-top':''" style="border-color:#e9e9e9 !important">
                                <b-td :style="item.symbol && item.symbol.length<6 ? 'width:80px ':'white-space:nowrap'">
                                  <EquationViewer :value="item.symbol? item.symbol : '-'"></EquationViewer>
                                </b-td>
                                <b-td style="vertical-align:middle">
                                  {{item.description}}
                                </b-td>
                              </b-tr>
                            </b-tbody>
                          </b-table-simple>
                        </div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{similarity(indicator.formula, item.data.indicator.formula)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="ind--disaggregations" class="field">
            <div class="field__form">
              <div class="bg-white" style="margin:-20px -30.5px 0px -30.5px">
                <div class="border-bottom" style="padding:15px 30px;background:#f3f3f3;">
                  <div class="text-13 text-bold border-bottom pb-1">Disaggregasi Indikator</div>
                  <div class="text-11 pt-1">
                    Ketika suatu indikator diperlukan untuk diperinci lebih detil dalam penyebaran datanya, 
                    sejumlah variabel digunakan untuk mengklasifikasikan indikator tersebut. 
                    <span class="text-danger">Contoh: penggunaan variabel wilayah (Aceh, Sumatera Utara, lainnya) dan Jenis Kelamin sebagai disaggregasi 
                    Indikator <b>Jumlah Pendududuk</b> </span>
                  </div>
                </div>
                <div style="padding:20px 30px 5px 30px">
                  <ValidationProvider name="Disaggregasi Indikator" rules="required" v-slot="{errors}">
                    <b-form-group label="Pilih variabel">
                      <Treeselect 
                        placeholder="Pilih variabel"
                        clearable
                        valueFormat="object"
                        v-model="indicatorDisaggregations" 
                        :class="errors[0] ? 'invalid': (indicatorDisaggregations.length>0 ? 'valid' : null)"
                        :multiple="true" 
                        :options="options.variable"
                        :async="true"
                        :loadOptions="variableReferenceLoadOptions"
                        :normalizer="variableNormalizer"
                          @input="indicatorDisaggregationsChanged"
                      >
                      <div slot="option-label" slot-scope="{node}" class="border-bottom" style="padding: 10px 8px;">
                        <div class="d-flex align-items-center" >
                          <div class="mr-2">
                            <div style="color:#00897B;line-height: normal;font-weight:700">{{node.raw.name}}</div>
                            <div class="i-text-13 mt-1" style="color:#757575;line-height: normal;" >{{node.raw.definition}}</div>
                          </div>
                          <div class="ml-auto badge" :class="node.raw.source=='SDSN' ? 'badge--primary':'badge--secondary'">{{node.raw.source.toLowerCase()}}</div>
                        </div>
                      </div>
                      </Treeselect>
                      <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                  <div class="table-wrapper mb-3">
                    <b-table-simple class="table--light" >
                      <b-thead>
                        <tr>
                          <th class="text-center w-30">No</th>
                          <th class="text-left w-150">Nama</th>
                          <th class="text-left">Definisi</th>
                          <th class="text-center w-80">Status</th>
                          <th class="text-center w-auto"></th>
                        </tr>
                      </b-thead>
                      <b-tbody >
                        <b-tr v-for="(item,index) in indicatorDisaggregations" :key="index">
                          <b-td class="text-center w-auto">{{index+1}}</b-td>
                          <b-td class="text-left">{{item.name}}</b-td>
                          <b-td class="text-left">{{item.definition}}</b-td>
                          <b-td class="text-center w-auto text-nowrap">
                            <div :class="'status status--'+statusFormatterStyle(item.status)" >
                              {{statusFormatter(item.status)}}
                            </div>
                          </b-td>
                          <b-td class="text-center w-auto">
                            <b-button v-if="item.status == 'REJECTED'" type="button" class="button button--small button--text"  >
                              <VueFeather type="repeat" size="16" stroke-width="2"></VueFeather>
                            </b-button>
                            <!-- <b-button v-else type="button" class="button button--small button--text" @click="showConceptReferenceDetail(item)" >
                              <VueFeather type="eye" size="16" stroke-width="2" ></VueFeather>
                            </b-button> -->
                          </b-td>
                        </b-tr>
                        <b-tr v-if="indicatorDisaggregations.length==0">
                          <b-td class="text-danger text-center" colspan="6">
                            <div class="d-flex align-items-center justify-content-center py-1">
                              <VueFeather type="alert-circle" size="18" style="display:block"></VueFeather> &nbsp; Tidak variabel yang digunakan sebagai aggregasi
                            </div>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
              </div>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.disaggregations.length>0).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Disaggregasi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-101">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.disaggregations.length>0).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>
                      <div class="d-flex" v-for="(disaggregation,index) in item.disaggregations" :key="index">
                        <div class="min-w-20" v-if="item.disaggregations.lenght>1">{{index+1}}.</div>
                        <div>{{disaggregation.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center">{{disaggregationsSimilarity(indicator.disaggregations, item.disaggregations)}}</b-td>
                    <b-td class="text-left">SDSN</b-td>
                    <b-td class="text-center">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.indicator.disaggregations" :key="index2">
                        <div class="min-w-20" v-if="item.data.indicator.disaggregations.length>1">{{index2+1}}.</div>
                        <div>{{item2.name}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{disaggregationsSimilarity(indicator.disaggregations, item.data.indicator.disaggregations)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
          <div id="ind--references" class="field" >
            <div class="field__form">
              <ValidationObserver ref="indicatorReferencesObserver">
                <b-form-group label="Sumber referensi yang digunakan">
                  <b-table-simple class="table--form">
                    <b-tbody >
                      <b-tr v-for="(item,index) in indicator.references" :key="index">
                        <b-td class="w-40">
                          <b-form-input :value="index+1" disabled style="text-align:center" size="sm"></b-form-input>
                        </b-td>
                        <b-td>
                          <ValidationProvider :name="'Sumber referensi ke-'+(index+1)" rules="required" v-slot="{errors}">
                            <b-form-input 
                              type="search"
                              placeholder="Tuliskan sumber referensi dari indikator yang diusulkan"
                              v-model="indicator.references[index]"
                              :state="errors[0] ? false: (item ? true : null)"
                              size="sm"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-td>
                        <td class="w-34">
                          <b-button 
                            class="button button--action button--action--sm button--danger" 
                            v-on:click="deleteIndicatorReference(index)" 
                            :disabled="indicator.references.length==1? true: false"
                          >
                            <VueFeather type="x" size="17"></VueFeather>
                          </b-button>
                        </td>
                      </b-tr>
                      <tr>
                        <td class="my-0"></td>
                        <td class="my-0">
                          <div class="d-flex justify-content-end">
                            <b-button class="button button--secondary" 
                              v-on:click="addIndicatorReference" >Tambah Referensi</b-button>
                          </div>
                        </td>
                        <td class="my-0"></td>
                      </tr>
                    </b-tbody>
                  </b-table-simple>
                </b-form-group>
              </ValidationObserver>
            </div>
            <div class="field__similarity" v-if="(isUpdate && indicator.updated_indicator.items.filter(x=>x.references.length>0).length>0) || similarSdsItems.length>0">
              <b-table-simple class="table--outlined">
                <b-thead>
                  <tr>
                    <th class="text-left">Referensi serupa</th>
                    <th class="text-center w-101">Kemiripan</th>
                    <th class="text-left w-170">Produsen Data</th>
                    <th class="text-center w-80">Status</th>
                  </tr>
                </b-thead>
                <b-tbody v-if="isUpdate && indicator.updated_indicator.items.filter(x=>x.references.length>0).length>0">
                  <b-tr v-for="(item) in indicator.updated_indicator.items" :key="item.id">
                    <b-td>
                      <div class="d-flex" v-for="(reference,index) in item.references" :key="index">
                        <div class="min-w-20" v-if="item.references.length>1">{{index+1}}.</div>
                        <div>{{reference ? reference : '-'}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{referencesSimilarity(indicator.references, item.references)}}</b-td>
                    <b-td class="text-left w-auto">SDSN</b-td>
                    <b-td class="text-center w-auto">
                      <div class="status status--published">Publish</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
                <b-tbody >
                  <b-tr v-for="(item,index) in similarSdsItems" :key="index">
                    <b-td>
                      <div class="d-flex" v-for="(item2,index2) in item.data.indicator.references" :key="index2">
                        <div class="min-w-20" v-if="item.data.indicator.references.length>1">{{index2+1}}.</div>
                        <div>{{item2 ? item2 : '-'}}</div>
                      </div>
                    </b-td>
                    <b-td class="text-center w-auto">{{referencesSimilarity(indicator.references, item.data.indicator.references)}}</b-td>
                    <b-td class="text-left w-auto">{{item.produsen_data_name}}</b-td>
                    <b-td class="text-center text-nowrap">
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </div>
        </ValidationObserver>

        <div v-else class="loading">
          <img src="@/assets/icons/loading-plane.gif" width="200" height="200" />
          <div style="margin-top:-60px">
            Sedang mengambil data ke server, harap tunggu sebentar....
          </div> 
        </div>

      </b-col>
      <Transition name="fade">
        <b-col id="review" cols="3" class="pr-0 mr-0"  v-if="reviewVisible">
          <div class="review ml-0" style="margin-right:15px;top:118px">
            <div class="review__header">
              <div class="review__header__icon">
                <VueFeather type="mail" size="16" stroke-width="2" style="display:block"></VueFeather>
              </div>
              <div class="review__header__title">
                Catatan Pemeriksaan
              </div>
              <div class="review__header__close ml-auto">
                <button class="button" variant="icon" size="sm" @click="reviewVisible = !reviewVisible">
                  <VueFeather type="x" size="16" stroke-width="2" style="display:block"></VueFeather>
                </button>
              </div>
            </div>
            <div class="review__body" style="overflow-y:auto;max-height:calc(90vh - 290px)">
              <div style="margin-bottom:20px;" v-if="form.reviews && form.reviews.length>0" >
                <div v-for="(review, reviewIndex) in form.reviews" :key="reviewIndex" class="review-item d-block">
                  <div class="d-flex">
                      <div class="review-item__number">{{reviewIndex+1}}.</div>
                      <div class="review-item__note">
                        <span class="review-item__field">
                        {{review.field ? ('#'+ review.field + ' : ') : ''}}
                        </span>
                        {{review.note}}
                      </div>
                  </div>
                  <div class="d-flex align-items-center review-item__info pt-1 " style="padding-left:19px">
                      <div class="text-10 text-500 mr-2 " style="line-height:1" v-if="review.created_at">{{review.created_at | formatDate}}</div>
                      <div class="text-10 text-500 mr-2 " style="line-height:1" v-else>{{sdsItem.created_at | formatDate}}</div>
                      <div class="ml-auto">
                        <b-button  
                            class="button button--action button--action--delete " style="height:20px;width:20px!important;min-width:20px!important" v-b-tooltip.hover title="Periksa"
                            @click="form.reviews.splice(reviewIndex,1)"
                            >
                            <VueFeather type="x" size="12"></VueFeather>
                        </b-button>
                      </div>
                  </div>
                </div>
              </div>
              <div class="history-review" v-if="sdsItem" >
                <div class="text-bold text-primary" style="margin:5px 11px">History Pemeriksaan:</div>
                <div v-if="reviewHistories.length==0" class="" style="margin-top:-5px;margin-left:11px"> Belum ada history yang tersedia</div>
                <div v-else class="mt-1">
                  <div v-for="(review, reviewIndex) in reviewHistories" :key="reviewIndex" class="review-item d-block">
                      <div class="d-flex">
                          <div class="review-item__number">{{reviewIndex+1}}.</div>
                          <div class="review-item__note">
                            <span class="review-item__field">
                            {{review.field ? ('#'+ review.field + ' : ') : ''}}
                            </span>
                            {{review.note}}
                          </div>
                      </div>
                      <div class="d-flex align-items-center review-item__info pt-1 " style="padding-left:19px" v-if="review.created_at">
                          <div class="text-10 text-500 mr-2 " style="line-height:1" >{{review.created_at | formatDate}}</div>
                      </div>
                  </div>
                </div>
                
            </div>


            </div>
            <div class="review__footer form form--sm mt-auto">
              <Treeselect  
                placeholder="Pilih attribute yang diberikan catatan"
                v-model="review.field" 
                :options="field" :disable-branch-nodes="true" 
                :clearable="true" 
                :loadOptions="loadOptions">
              </Treeselect>
              <b-form-textarea 
                class="mt-1 text-13"
                rows="3"
                v-model="review.note" 
                placeholder="Tuliskan secara jelas catatan pemeriksaan" 
              >
              </b-form-textarea>
              <div class="d-flex justify-content-end mt-2">
                <button  class="button" variant="primary" size="sm" @click="AddReview">
                  <VueFeather type="plus" size="14" stroke-width="2"></VueFeather> &nbsp; Tambah Catatan
                </button>
              </div>
            </div>
          </div>
        </b-col>
      </Transition>
      
    </b-row>

    <b-modal hide-header hide-footer size="lg" id="modal-variable-reference" modal-class="modal modal--primary" >
      <div class="modal__header">
        <div class="modal__header__title">
          <div class="modal__header__title__name"> 
            <VueFeather type="info" size="22" stroke-width="2"></VueFeather> &nbsp;&nbsp;Detail Variabel
          </div>
        </div>
        <div class="modal__header__close">
          <button  class="button button--action" @click="$bvModal.hide('modal-variable-reference')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body" v-if="variableReference">
        <b-table-simple class="table--stacked table--stacked--primary" >
          <b-tbody>
            <b-tr>
              <b-th>Nama</b-th>
              <b-td>{{variableReference.name}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Definisi</b-th>
              <b-td>{{variableReference.definition}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Konsep</b-th>
              <b-td>
                <div v-for="(item,index) in variableReference.concepts" :key="index" :class="index==0? '': 'pt-2 border-top'">
                  <div class="text-semi-bold" style="color:teal">{{item.name}}</div>     
                  <div >{{item.definition}}</div>
                  <div class="d-flex mt-2">
                    <div>
                      <div :class="'status status--'+statusFormatterStyle(item.status)">{{statusFormatter(item.status)}}</div>
                    </div>
                  </div>
                </div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Unit Observasi</b-th>
              <b-td>
                <div v-for="(item,index) in variableReference.unit_types" :key="index" class="d-flex">
                  <div class="d-flex">
                    <div style="width:20px" v-if="variableReference.unit_types.length>1">{{index+1}}.</div>
                    <div>{{item.name}}</div>
                  </div>
                </div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Ukuran</b-th>
              <b-td>{{variableReference.measurement ? variableReference.measurement.name: '-'}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Satuan</b-th>
              <b-td>{{variableReference.measurement_unit ? variableReference.measurement_unit.name: '-'}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Subyek</b-th>
              <b-td>{{variableReference.subject_field ? variableReference.subject_field.name: '-'}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Jenis value domain</b-th>
              <b-td>{{variableReference.value_domain.type.id == 76 ? 'Kategori':'Non Kategori'}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Item value domain</b-th>
              <b-td>
                <div class="d-flex border-bottom py-1 mb-2">
                  <div class="text-center w-34 text-semi-bold">Kode</div>
                  <div class="w-200 px-2 text-semi-bold">Nama</div>
                  <div class="flex-grow-1 px-2 text-semi-bold">Deskripsi</div>
                </div>
                <div class="d-flex" v-for="(item,index) in variableReference.value_domain.classification.items" :key="index">
                  <div class="text-center w-34">{{item.code ? item.code : '-'}}</div>
                  <div class="w-200 px-2 word-break">{{item.name ? item.name : '-'}}</div>
                  <div class="flex-grow-1 px-2 word-break">{{item.description ? item.description : '-'}}</div>
                </div>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Aturan validasi</b-th>
              <b-td>{{variableReference.rule}}</b-td>
            </b-tr>
            <b-tr>
              <b-th>Referensi</b-th>
              <b-td>
                <div v-for="(item,index) in variableReference.references" :key="index">
                  <div class="w-60" v-if="variableReference.references.length>1">{{index+1}}.</div>
                  <div>{{item.name}}</div>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <div class="modal__footer border-top-0 pt-0" v-if="variableReference">
        <div class="modal__footer__action">
          <b-button class="button" :class=" variableReference.method == 'UPDATE' ? 'button--outlined':'button--primary'" @click="$bvModal.hide('modal-variable-reference');">
            {{variableReference.method == 'UPDATE' ? 'Batal':'Tutup'}}
          </b-button>
          <b-button class="button button--primary" @click="changeVariableReference" v-if="variableReference.method == 'UPDATE'">Gunakan Konsep ini</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="xl" id="modal-value-domain" modal-class="modal modal--warning">
      <div class="modal__header border-bottom-0">
        <div class="modal__header__title">
          <div class="modal__header__title__name"> 
            <VueFeather type="edit-3" size="22" stroke-width="2"></VueFeather> &nbsp;&nbsp;Tambah Item Value Domain 
          </div>
        </div>
        <div class="modal__header__close">
          <button  class="button button--action button--outlined" @click="$bvModal.hide('modal-value-domain')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body">
        <div class="d-flex align-items-end">
          <div class="text-medium text-16">Daftar Item Klasifikasi </div>
          <div class="d-flex ml-auto align-items-center">
            <label class="text-nowrap m-0 mr-1 text-medium">Jumlah baris:</label>
            <b-form-select v-model="modal.valueDomain.table.pagination.pageSize" :options="options.page" size="sm" ></b-form-select>
          </div>
          
        </div>
        <div class="table-search form">
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Pilih Versi Klasifikasi"
            v-model="modal.valueDomain.statClass"
            :options="options.statistical_classification"
            :normalizer="normalizer"
            @input="options.statistical_classification_level = modal.valueDomain.statClass.levels"
          >
          </Treeselect>
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Pilih Level"
            v-model="modal.valueDomain.level"
            :options="options.statistical_classification_level"
            :normalizer="normalizer"
            :disabled="!modal.valueDomain.statClass" 
            :loadOptions="loadOptions"
            
          >
          </Treeselect>
          
          <b-form-input 
              class="w-400 md"
              type="search"
              debounce="500"
              v-model="modal.valueDomain.name" 
              placeholder="Cari nama item klasifikasi" ></b-form-input>

          <b-button 
            :disabled="modal.valueDomain.statClass == null"
            type="button" 
            class="button button--primary button--md" 
            @click="searchValueDomainItems">
            <VueFeather type="search" size="14" class="button__icon"></VueFeather>Cari Item
          </b-button>
        </div>
        <div class="table-wrapper mt-2">
          <b-table
            class="table--light"
            show-empty
            :items="modal.valueDomain.table.items"
            :fields="modal.valueDomain.table.fields"
          >
            <template #head(selected)>
              <b-form-checkbox class="min-h-0"
                @change="(checked)=>{
                  modal.valueDomain.table.items.forEach(x => {
                    x.selected = checked
                  })
                }"
              ></b-form-checkbox>
            </template>
            <template #cell(selected)="data">
              <b-form-checkbox v-model="data.item.selected"></b-form-checkbox>
            </template>
            <!-- <template #cell(no)="data">
              {{ startRowNumber + data.index}}
            </template> -->

            <template #empty>
              <div class="table__empty">
                <div v-if="modal.valueDomain.table.isLoading">
                  <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                <div v-else class="d-flex flex-column">
                  <div>
                    Tidak ada data yang tersedia
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="modal.valueDomain.table.pagination.currentPage"
            :total-rows="modal.valueDomain.table.pagination.totalElements"
            :per-page="modal.valueDomain.table.pagination.pageSize"
            align="center"
            @input="searchValueDomainItems"
            v-if="modal.valueDomain.table.pagination.totalElements>0 && modal.valueDomain.table.isLoading == false"
          ></b-pagination>
        </div>
      </div>
      <div class="modal__footer">
        <div class="d-flex ml-auto mx-1">
          <b-button type="button" class="button button--outlined" @click="$bvModal.hide('modal-value-domain')">Batal</b-button>
          <!-- <b-button type="button" class="button button--warning ml-2" @click="saveUpdatingSubmissionTypeModal">Simpan</b-button> -->
          <b-button type="button" class="button button--warning ml-2" @click="saveItemAsValueDomain">Simpan sebagai item value domain</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="sm" id="modal-saving"  content-class="text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div v-if="saveState=='SAVING'">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Proses menyimpan sedang berlangsung 
          </div>
        </div>
      </div>
      <div v-if="saveState=='SUCCESS'">
        <div class="text-center py-3">
          <img src="@/assets/img/success.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Berhasil menyimpan 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Anda akan di <i>redirect</i> ke halaman approval dalam beberapa detik
          </div>
        </div>
      </div>
      <div v-if="saveState=='ERROR'">
        <div class="text-center py-3" style="color:red">
          <div >
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error 
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{saveError}} 
          </div>
          <div class="mt-2">
            <b-button 
              style="background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-saving');}">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="sm" id="modal-error"  content-class="modal--error text-center mt-5" dialog-class="d-flex justify-content-center">
      <div>
        <div class="text-center py-5 px-2" style="color:red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div class="border mx-4 " style="border-color:#F48FB1 !important;width:40%">
              <div style="position:relative;background-color:#FCE4EC;height:20px;border-color:#F48FB1 !important" class="border-bottom mb-2" >
                <div style="position:absolute;top:-10px;right:-10px"><VueFeather type="x-circle" size="20" stroke-width="1.5" fill="#FCE4EC"></VueFeather></div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton animation width="85%" height="10px" style="background-color:#fff1f6;border:1px solid #F8BBD0;margin-bottom:10px"></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            {{modal.error.title}} 
          </div>
          <div style="font-weight:500;font-size:13px;color:#616161;word-break: break-word;">
            {{modal.error.description}} 
          </div>
          <div class="mt-3">
            <b-button 
              class="i-button"
              style="color:white !important;background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-error');}">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="xl" id="modal-save-submission" modal-class="modal modal--warning">
      <div class="modal__header border-bottom-0">
        <div class="modal__header__icon">
          <VueFeather type="send" size="22" stroke-width="2"></VueFeather>
        </div>
        <div class="modal__header__title">
          <div class="modal__header__title__name"> 
            Simpan usulan 
          </div>
          <div class="modal__header__title__description"> 
            Pastikan pemeriksaan telah dilakukan dengan benar sebelum mengirim data ke server
          </div>
        </div>
        <div class="modal__header__close">
          <button  class="button button--action button--outlined" @click="$bvModal.hide('modal-save-submission')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body">
        <div class="form text-medium" style="border-radius:4px">
          <ValidationObserver ref="saveSubmissionObserver">
            <b-form-group label="Status Usulan">
              <Treeselect  
                :clearable="false" 
                v-model="form.status" 
                :options="status" :disable-branch-nodes="true" 
                :loadOptions="loadOptions" class="valid"
                @input="statusChanged"
                
              >
              </Treeselect>
            </b-form-group>

            <div class="alert alert--warning d-block" v-if="isApproved && similarSdsItems.length>0">
              <div class="d-flex">
                <div>
                  <b-form-checkbox v-model="isRejectSimilarItems" @input="rejectSimilarItemsChecked"></b-form-checkbox>
                </div>
                <div>
                  <div class="text-bold text-13">Tolak semua usulan yang mirip</div>
                  <div class="text-11">Ketika opsi ini dicek maka semua usulan yang mirip yang sudah dipilih saat membandingkan dengan usulan yang
                    disetujui akan ditolak semua. usulan yang ditolak kemudian akan diset alterntifnya dengan usulan yang di setujui
                  </div>
                </div>
              </div>

              <div class="d-flex mt-3 pt-3" style="border-top: 1px solid #eadaa6" v-if="isApprovedPusat">
                <div>
                  <b-form-checkbox v-model="form.proposed_walidata_pusat"></b-form-checkbox>
                </div>
                <div>
                  <div class="text-bold text-13">
                    Usulkan ke Pembina Data
                  </div>
                  <div class="text-11">
                    Pilih opsi ini jika ingin mengusulkan SDS sebagai usulan SDSN
                  </div>
                </div>
              </div>

            </div>


            <ValidationProvider immediate name="Jenis penolakan"  rules="required" v-slot="{errors}" v-if="isRejected">
              <b-form-group label="Jenis penolakan">
                <Treeselect 
                  :clearable="false"
                  placeholder="Pilih jenis alasan penolakan"
                  v-model="rejectionNote.type"
                  :class="errors[0] ? 'invalid': ( rejectionNote.type ? 'valid' : null)"
                  :options="options.rejected_status_type"
                  :loadOptions="loadOptions"
                />
                
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            
            </ValidationProvider>

            <ValidationProvider immediate name="Catatan"  v-if="rejectionNote.type == 'OTHER'"  rules="required" v-slot="{errors}">
              <b-form-group label="Catatan">
                <b-form-textarea 
                  rows="3"
                  v-model="rejectionNote.note" 
                  placeholder="Tuliskan secara jelas deskripsi ukuran" 
                  :state="errors[0] ? false: ( form.rejected_status_note ? true : null)"
                >
                </b-form-textarea>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider 
              immediate :name="'Alternatif '+ form.sds_type == 'INDICATOR' ? 'Indikator' : (form.sds_type == 'VARIABLE' ? 'Variabel' : 'Konsep & Definisi')"  
              rules="required" v-slot="{errors}" 
              v-if="rejectionNote.type =='SIMILAR_SDSN_ALREADY_EXISTS' || rejectionNote.type == 'SIMILAR_REQUEST_ALREADY_EXISTS'"
            >
              <b-form-group 
                :label="'Alternatif '+ sdsTypeLabel"   
                :description="sdsTypeLabel+' Adalah '+sdsTypeLabel+' yang sudah disetujui oleh pemeriksa'"
              >
                <Treeselect 
                  :placeholder="rejectionNote.type =='SIMILAR_SDSN_ALREADY_EXISTS' ? 'Pilih SDSN': 'Pilih Alternatif Usulan'+ sdsTypeLabel"  
                  clearable
                  valueFormat="object"
                  v-model="alternativeSdsItem" 
                  :class="errors[0] ? 'invalid': (form.alternative_sds_item_id ? 'valid' : null)"
                  :async="true"
                  :cacheOptions="false"
                  :loadOptions="alternativeSdsItemLoadOptions"
                  :normalizer="normalizer"
                  @input="form.alternative_sds_item_id = alternativeSdsItem.id"
                  searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
                >
                  <div slot="option-label" slot-scope="{node}" class="border-bottom" style="padding: 3px 8px;">
                    <div class="d-flex align-items-center">
                      <div >{{node.raw.name}}</div>
                      <div class="d-flex justify-content-end align-items-center ml-auto ">
                        <span class="text-12 mr-2">{{node.raw.produsen_data_name}}</span>
                        <span :class="'text-nowrap status status--'+statusFormatterStyle(node.raw.status)">{{statusFormatter(node.raw.status)}}</span>
                      </div>   
                    </div>
                  </div>
                </Treeselect>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
            <SdsItemViewer v-if="form.alternative_sds_item_id" :id="form.alternative_sds_item_id"/>

          </ValidationObserver>
        </div>
      </div>
      <div class="modal__footer">
        <div class="d-flex ml-auto mx-1" v-show="sdsItemChangeType">
          <button type="button" class="button " variant="outlined" @click="$bvModal.hide('modal-save-submission')">Batal</button>
          <button type="button" class="button ml-2" variant="primary" @click="sendData">Kirim</button>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="xl" id="modal-similar-item" modal-class="modal modal--warning" >
        <div class="modal__header border-bottom-0">

          <div class="modal__header__icon">
            <VueFeather type="layers" size="22" stroke-width="2"></VueFeather>
          </div>
          <div class="modal__header__title">
            <div class="modal__header__title__name"> 
              Usulan Serupa
            </div>
            <div class="modal__header__title__description"> 
              Fitur ini dapat digunakan untuk membandingkan usulan dengan usulan lain yang mirip
            </div>
          </div>
          <div class="modal__header__close">
            <button  class="button button--action" @click="$bvModal.hide('modal-similar-item')">
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <div class="table-wrapper mt-3 mb-4">
            <b-table
              class="table--light"
              show-empty
              :items="setting.similar_submission.items.filter(x=>x.sds_type == form.sds_type)"
              :fields="setting.similar_submission.fields"
            > 
              <template #cell(selected)="data">
                <b-form-checkbox v-model="data.item.selected"></b-form-checkbox>
              </template>
              <template #cell(no)="data">
                {{data.index+1}}
              </template>
              <template #cell(sds_type)="data">
                {{ data.value == 'CONCEPT' ? 'Konsep':(data.value == 'VARIABLE' ? 'Variabel':'Indikator')}}
              </template>
              <template #cell(similarity)="data">
                {{data.value.toFixed(2) + '%'}}
              </template>
              <template #cell(status)="data">
                <span :class="'status status--'+statusFormatterStyle(data.value)">{{statusFormatter(data.value)}}</span>
              </template>
              <template #empty>
                <div class="text-danger d-flex justify-content-center align-items-center py-2  i-text-semi-bold">
                  <div v-if="setting.similar_submission.isLoading" class="d-flex align-items-center justify-content-center text-bold">
                    <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data
                  </div>
                  <div v-else class="d-flex align-items-center justify-content-center">
                    <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;Tidak ada usulan lain yang mirip                  </div>
                  </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="modal__footer">
          <div class="d-flex ml-auto mx-1">
            <b-button type="button" class="button button--outlined mr-2" @click="$bvModal.hide('modal-similar-item')">Batal</b-button>
            <b-button type="button" class="button button--primary" @click="saveSimilarSdsItem">Simpan</b-button>
          </div>
        </div>
    </b-modal>
    <b-modal hide-header hide-footer size="lg" id="modal-sds-type" modal-class="modal modal--warning" >
      <div class="modal__header border-bottom-0">
        <div class="modal__header__icon">
          <VueFeather type="edit-3" size="22" stroke-width="2"></VueFeather>
        </div>
        <div class="modal__header__title">
          <div class="modal__header__title__name"> 
             Ubah jenis SDS 
          </div>
          <div class="modal__header__title__description"> 
            Fitur ini digunakan untuk mengubah jenis SDS karena kesalahan pengusul dalam menentukan jenis SDS
          </div>
        </div>
        <div class="modal__header__close">
          <button  class="button button--action" @click="$bvModal.hide('modal-sds-type')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body">
        <div class="form form--sm text-medium" style="border-radius:4px">
          <ValidationObserver ref="updatesdsTypeObserver">
            <ValidationProvider immediate name="Jenis SDS"  rules="required" v-slot="{errors}">
              <b-form-group label="Jenis SDS">
                <b-form-radio-group v-model="setting.sds_type" :options="options.sds_type" ></b-form-radio-group>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </ValidationObserver>
        </div>
        <div class="alert alert--warning">
          <div class="alert__icon">
            <VueFeather type="alert-triangle" size="32"></VueFeather>
          </div>
          <div class="alert__value">
            Perubahan jenis SDS akan mengakibatkan beberapa isian attribut hilang dan beberapa isian yang masih kosong, sehingga pengusul harus mengisi dahulu 
            attribut yang kosong tersebut.
          </div>
        </div>
      </div>
      <div class="modal__footer">
        <div class="d-flex ml-auto mx-1">
          <b-button type="button" class="button button--outlined" @click="$bvModal.hide('modal-sds-type')">Batal</b-button>
          <b-button type="button" class="button button--primary ml-2" @click="saveUpdatingSdsTypeModal">Simpan</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="xl" id="modal-submission-type" modal-class="modal modal--warning" >
      <div class="modal__header border-bottom-0">
        <div class="modal__header__icon">
          <VueFeather type="edit-3" size="22" stroke-width="2"></VueFeather>
        </div>
        <div class="modal__header__title">
          <div class="modal__header__title__name"> 
             Ubah Jenis Usulan 
          </div>
          <div class="modal__header__title__description"> 
            Fitur ini digunakan untuk mengubah jenis usulan atau menambahkan SDSN yang ingin dipemutakhirkan
          </div>
        </div>
        <div class="modal__header__close">
          <button  class="button button--action" @click="$bvModal.hide('modal-submission-type')">
            <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </button>
        </div>
      </div>
      <div class="modal__body">
        <div class="form form--sm text-medium" style="border-radius:4px">
          <ValidationObserver ref="updateSubmissionTypeObserver">
            <ValidationProvider immediate name="Jenis usulan"  rules="required" v-slot="{errors}" >
              <b-form-group label="Jenis Usulan">
                <b-form-radio-group 
                  v-model="setting.submission_type" 
                  :options="options.submission_type"
                >
                </b-form-radio-group>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group label="Jenis perubahan" v-if="setting.submission_type == 'UPDATE'">
                <b-form-radio-group 
                  v-model="setting.submission_changes_type" 
                  :options="options.submission_changes_type"
                >
                </b-form-radio-group>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>            
          </ValidationObserver>
        </div>
        <div class="alert alert--warning">
          <div class="alert__icon">
            <VueFeather type="alert-triangle" size="24"></VueFeather>
          </div>
          <div class="alert__value">
            Perubahan jenis usulan dari <b>Pemutakhiran</b> menjadi <b>Baru</b> akan membuat informasi acuan referensi <b>Standar Data Statistik Nasional (SDSN)</b> 
            akan hilang.
          </div>
          
        </div>
        <div class="form form--sm mb-3" v-if="setting.submission_type == 'UPDATE'">
          <b-form-group label="Pilih SDSN yang dimutakhirkan">
            <b-input-group>
              <template #prepend>
                <b-dropdown :text="setting.sdsn.selected_filter_field.label" toggle-class="button button--sm button--primary w-101">
                  <b-dropdown-item 
                    v-for="field in setting.sdsn.filter_fields" :key="field.id"
                    @click="setting.sdsn.selected_filter_field = field"
                  >
                    {{field.label}}
                  </b-dropdown-item>
                </b-dropdown>
              </template>

              <b-form-input 
                v-model="setting.sdsn.filter_text" 
                placeholder="Cari SDSN . . ."
                type="search"
                debounce="400"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          
          <div class="table-wrapper">
            <b-table
              class="table--light"
              show-empty
              :items="setting.sdsn.filtered_items"
              :fields="setting.sdsn.fields"
              :current-page="setting.sdsn.pagination.current_page"
              :per-page="setting.sdsn.pagination.page_size"
            >
              <template #cell(selected)="data">
                <b-form-checkbox v-model="data.item.selected" @change="sdsnSelected(data.item.selected, data.item.id)"></b-form-checkbox>
              </template>
              <template #cell(no)="data">
                {{ ((setting.sdsn.pagination.current_page-1)*setting.sdsn.pagination.page_size) + data.index+1}}
              </template>
              <template #cell(similarity)="data">
                {{data.value + '%'}}
              </template>
              <template #empty>
                <div class="table__empty">
                  <div v-if="setting.sdsn.isLoading">
                    <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
                  <div v-else>
                    <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                      Tidak ada data yang tersedia
                  </div>
                </div>
              </template>
            </b-table>
            <b-pagination
              class="mt-3 "
              v-model="setting.sdsn.pagination.current_page"
              :total-rows="setting.sdsn.filtered_items.length"
              :per-page="setting.sdsn.pagination.page_size"
              align="center"
              v-if="setting.sdsn.filtered_items.length>0 && setting.sdsn.isLoading == false"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div class="modal__footer">
        <div class="d-flex ml-auto mx-1" v-show="sdsItemChangeType">
          <b-button type="button" class="button button--outlined" @click="$bvModal.hide('modal-submission-type')">Batal</b-button>
          <b-button type="button" class="button button--warning ml-2" @click="saveUpdatingSubmissionTypeModal">Simpan</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// defaul scss
import "@/assets/scss/main.scss";
import "@/assets/scss/text.scss";
import EquationEditor from "@/components/equation/EquationEditor";
import EquationViewer from "@/components/equation/EquationViewer";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFeather from 'vue-feather';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import SdsItemViewer from "../../../components/SdsItemViewer.vue";
import organizationService from "../../../services/MainService";
import mmsService from "../../../services/MmsService";
import sdsService from "../../../services/SdsService";
import wilayahService from "../../../services/WilayahService";
import store from "../../../store";

import SubjectField from '../data/subject_field.js';
import User from '../data/user.js';

import stringSimilarity from 'string-similarity';
import { ValueDomain, ValueDomainItem } from '../data/variable.js';

export default {
  name:'CreateUsulanV2',
  components: {
    VueFeather,
    ValidationObserver,
    ValidationProvider,
    Treeselect,
    EquationEditor,
    EquationViewer,
    SdsItemViewer,
    'multiselect': Multiselect,
  },
  data() {
    return {
      alternativeSdsItem:null,
      sdsItem: null,
      sdsItemId: null,
      sdsItemChangeType: null,
      settingReleaseDate:null,
      settiingSubmissionPeriod:null,
      produsenData:null,
      walidata:null,
      province:null,
      city:null,
      isRejectSimilarItems:false,
      rejectionNote:{
        type:null,
        note:null,
      },
      review:{
        field:null,
        note:null
      },
      reviewVisible:true,
      similarSdsItems: [],
      
      error:null,
      saveState:'SUCCESS',
      saveError:null,
      id:null,
      concept: null,
      variable: null,
      variableConcepts:[],
      indicator: null,
      indicatorConcepts:[],
      indicatorDisaggregations:[],

      conceptReference:null,
      variableReference:null,
      alternativeConcepReference:null,
      alternativeVariableReference:null,

      alternativeConcept:null,
      alternativeVariable:null,
      alternativeIndicator:null,

      form: {
        data: {
          concept: null,
          variable: null,
          indicator: null,
        },
        submission_period: null,
        submission_type: null,
        sds_type: null,
        status: null,
        rejection_note: null,
        alternative_sds_item_id: null,
        rejected_similiar_item_ids:[],
        submitter: null,
        produsen_data: null,
        walidata_pusat: null,
        reviews:[],
        proposed_walidata_kabupaten_kota:	false,
        proposed_walidata_provinsi:	false,
        proposed_walidata_pusat:	false,

      },
      classificationReferenceId:null,
      classificationReferenceUsedType:'FULL',
      setting:{
        submission_type: null,
        submission_changes_type: 'MODIFY',
        sds_type: null,
        sdsn: {
          isLoading: false,
          selected_ids : [],
          items:[],
          filtered_items: [],
          filter_text: null,
          filter_fields:[
            {
              id: 'idSds',
              label: 'Kode SDSN',
            },
            {
              id: 'noIndikator',
              label: 'No. Indikator',
            },
            {
              id:'konsep',
              label:'Konsep',
            },
            {
              id:'definisi',
              label:'Definisi',
            },
            {
              id:'klasifikasi',
              label:'Klasifikasi',
            },
            {
              id:'ukuran',
              label:'Ukuran',
            },
            {
              id:'satuan',
              label:'Satuan',
            },
          ],
          selected_filter_field:{
            id:'konsep',
            label:'Konsep',
          },
          fields: [
            {
              key:'selected',
              label:'',
              class:'text-center'
            },
            {
              key:'no',
              class:'text-center'
            },
            {
              key: 'idSds',
              label: 'Kode SDSN',
              class:'text-left text-nowrap'
            },
            {
              key: 'noIndikator',
              label: 'No. Indikator',
              class:'text-left text-nowrap'
            },
            {
              key:'konsep',
              class:'text-left'
            },
            {
              key:'definisi',
              class:'text-left'
            },
            {
              key:'klasifikasi',
              class:'text-left'
            },
            {
              key:'ukuran',
              class:'text-left'
            },
            {
              key:'satuan',
              class:'text-left pr-3',
            },
            {
              key:'similarity',
              label: 'Kemiripan',
              class:'text-center'
            },
          ],
          pagination:{
            current_page:1,
            page_size: 7,
            total_pages: null,
          },
        },
        similar_submission:{
          isLoading:false,
          selected_ids : [],
          filtered_name: null,
          filtered_items: [],
          items:[],
          pagination:{
            currentPage:1,
            pageSize: 7,
            totalPages: null,
          },
          fields: [
            {
              key:'selected',
              label: '',
              class:'text-center w-40'
            },
            {
              key:'no',
              class:'text-center pl-4 w-20'
            },
            {
              key: 'sds_type',
              label: 'Jenis SDS',
              class:'text-left  w-110 pr-1'
            },
            {
              key:'name',
              label: 'Nama',
              class:'text-left'
            },
            {
              key:'similarity',
              label: 'Kemiripan',
              class:'text-center'
            },
            {
              key:'produsen_data_name',
              label: 'Produsen Data',
              class:'text-left w-200'
            },
            {
              key:'status',
              class:'text-center text-nowrap min-w-101'
            },
          ],
        },
      },
      modal:{
        error:{
          title:null,
          description:null,
        },
        valueDomain:{
          statClass:null,
          level:null,
          name:null,
          table:{
            isLoading:null,
            items: [],
            fields:[
              {
                key:'selected',
                label:'',
                class:'text-center w-51'
              },
              {
                key: 'code',
                label: 'Kode',
                class:'text-left text-nowrap w-101'
              },
              {
                key: 'name',
                label: 'nama',
                class:'text-left text-nowrap w-150'
              },
              {
                key:'description',
                label: 'deskripsi',
                class:'text-left'
              }
            ],
            pagination:{
              currentPage:1,
              pageSize: 10,
              totalPages: null,
              totalElements:0,
            },
          },
        }
      },
      user:new User(),
      userRoles:[],
      sdsn:[],
      selectedSdsn:null,
      formFilter:{
        name:null,
      },
      table:{
        isLoading:false,
        items: [],
        fields:[
          {
            key:'no',
            class:'text-center w-51'
          },
          {
            key: 'submission_type',
            label: 'Jenis Usulan',
            class:'text-left text-nowrap w-101'
          },
          {
            key: 'sds_type',
            label: 'Jenis Sds',
            class:'text-left text-nowrap w-70'
          },
          {
            key:'name',
            label: 'Nama',
            class:'text-left'
          },
          {
            key:'requester',
            label: 'Nama Pengentri',
            class:'text-left w-140'
          },
          {
            key:'requester_organization',
            label: 'Organisasi Pengentri',
            class:'text-left w-140'
          },
          {
            key:'produsen_data_name',
            label: 'Produsen Data',
            class:'text-left w-140'
          },
          {
            key:'created_at',
            label: 'Tanggal Usulan',
            class:'text-left text-nowrap w-110'
          },
          {
            key:'status',
            class:'text-center text-nowrap w-101'
          },
          
          {
            key:'action',
            label: 'Aksi',
            class:'text-center text-nowrap w-101'
          },
        ],
        pagination:{
          currentPage:1,
          pageSize: 10,
          totalPages: null,
          totalElements:0,
        },
      },
      filterIdSdsValue:null,
      filterIndicatorNoValue:null,
      filterConceptValue:null,

      
      options:{
        page:[
          { value: 10, text: '10' },
          { value: 20, text: '20' },
          { value: 50, text: '50' },
          { value: 100, text: '100' },
          { value: 500, text: '500' },
          { value: 1000, text: '1000' },
        ],
        submission_type:[
          { value: 'NEW', text: 'Baru'},
          { value: 'UPDATE', text: 'Pemutakhiran'}
        ],
        submission_changes_type:[
          { value: 'MODIFY', text: 'Modifikasi'},
          { value: 'MERGE', text: 'Gabung'},
          { value: 'SPLIT', text: 'Pecah'}
        ],
        sds_type:[
          {value:'CONCEPT', text:'Konsep'},
          {value:'VARIABLE', text:'Variable'},
          {value:'INDICATOR', text:'Indikator'},
        ],
        value_domain_type:[
          { value: { id: 75, name: 'Described Value Domain', description:'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi' }, text: 'Non Kategori',},
          { value: { id: 76, name: 'Enumerated Value Domain', description: 'Jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori' }, text: 'Kategori' },
        ],
        concept:[],
        variable:[],
        unit_type:[],
        measurement:[],
        measurement_unit:[],
        classification_series:[],
        statistical_classification:[],
        statistical_classification_level:[],
        presentation_level:[
          { value: { id: 148, name: 'Nasional', description: null}, text: 'Nasional'},
          { value: { id: 149, name: 'Provinsi', description: null}, text: 'Provinsi'},
          { value: { id: 150, name: 'Kabupaten/Kota', description: null}, text: 'Kabupaten/Kota'},
          { value: { id: 151, name: 'Kecamatan', description: null}, text: 'Kecamatan'},
          { value: { id: 152, name: 'Kelurahan/Desa', description: null}, text: 'Kelurahan/Desa'}
        ],
        subject_fields:null,
        concept_fields :[
          {id:'name', label:'nama'},
          {id:'definition', label:'definisi'},
          {id:'references', label:'referensi'},
        ],
        variable_fields :[
          {id:'name', label:'nama'},
          {id:'definition', label:'definisi'},
          {id:'concepts', label:'konsep'},
          {id:'unit-types', label:'unit observasi'},
          {id:'measurement', label:'ukuran'},
          {id:'measurement-unit', label:'satuan'},
          {id:'subject-field', label:'subyek'},
          {id:'value-domain-type', label:'jenis value domain'},
          {id:'value-domain-items', label:'item value domain'},
          {id:'rule', label:'aturan validasi'},
          {id:'references', label:'referensi'},
        ],
        indicator_fields :[
          {id:'name', label:'nama'},
          {id:'definition', label:'definisi'},
          {id:'concepts', label:'konsep'},
          {id:'measurement', label:'ukuran'},
          {id:'measurement-unit', label:'satuan'},
          {id:'subject-field', label:'subyek'},
          {id:'benefit', label:'manfaat'},
          {id:'interpretation', label:'interpretasi'},
          {id:'presentation-levels', label:'cakupan level wilayah'},
          {id:'calculation-mechanism', label:'mekanisme perhitungan'},
          {id:'formula', label:'rumus'},
          {id:'formula-structures', label:'struktur rumus'},
          {id:'disaggregations', label:'disaggregasi'},
          {id:'references', label:'referensi'},
        ],
        rejected_status_type :[
          {id:'SIMILAR_SDSN_ALREADY_EXISTS', label:'Sudah ada SDSN yang serupa'},
          {id:'SIMILAR_REQUEST_ALREADY_EXISTS', label:'Sudah ada Usulan yang serupa'},
          {id:'IMPROPERLY_REQUEST', label:'Usulan tidak layak'},
          {id:'REQUESTED_BY_USER', label:'Diminta oleh pengusul'},
          {id:'OTHER', label:'Lainnya'},
        ],
        
        status:[
          {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
          {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
          {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
          {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
          {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
          {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
          {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

          {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
          {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
          {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
          {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
          {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
          {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
          {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

          {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
          {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
          {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
          {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
          {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
          {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
          {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
          {value:'PUBLISHED_PUSAT', label:'Publish'},
        ],
        adminStatus:[
          {id:'KABKOTA', label:'Kabupaten/Kota', children:[
            {id:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
            {id:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
            {id:'REVISED_KABKOTA', label:'Revised Produsen Data Kabupaten/Kota'},
            {id:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
            {id:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
            {id:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
            {id:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
            {id:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},
          ]},
          {id:'PROVINSI', label:'Provinsi', children:[
            {id:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
            {id:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
            {id:'REVISED_PROVINSI', label:'Revised Produsen Data Provinsi'},
            {id:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
            {id:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
            {id:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
            {id:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
            {id:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},
          ]},
          {id:'PUSAT', label:'Pusat', children:[
            {id:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
            {id:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
            {id:'REVISED_PUSAT', label:'Revised Produsen Data Pusat'},
            {id:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
            {id:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
            {id:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
            {id:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
            {id:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
            {id:'PUBLISHED_PUSAT', label:'Publish'},
          ]},
        ],
        approverKabupatenKotaStatus:[
          {id:'DRAFT_KABKOTA', label:'Draft', isDisabled: true},
          {id:'SUBMITTED_KABKOTA', label:'Submit', isDisabled: true},
          {id:'REVISED_KABKOTA', label:'Sudah Diperbaiki', isDisabled: true},
          {id:'REVIEW_KABKOTA', label:'Sedang Diperiksa'},
          {id:'CORRECTION_KABKOTA', label:'Perlu Perbaikan'},
          {id:'REJECTED_KABKOTA', label:'Ditolak'},
          {id:'APPROVED_KABKOTA', label:'Diterima'},
        ],
        approverProvinsiStatus:[
          {id:'DRAFT_PROVINSI', label:'Draft', isDisabled: true},
          {id:'SUBMITTED_PROVINSI', label:'Submit', isDisabled: true},
          {id:'REVISED_PROVINSI', label:'Sudah Diperbaiki', isDisabled: true},
          {id:'REVIEW_PROVINSI', label:'Sedang Diperiksa'},
          {id:'CORRECTION_PROVINSI', label:'Perlu Perbaikan'},
          {id:'REJECTED_PROVINSI', label:'Ditolak'},
          {id:'APPROVED_PROVINSI', label:'Diterima'},
        ],
        approverPusatStatus:[
          {id:'DRAFT_PUSAT', label:'Draft', isDisabled: true},
          {id:'SUBMITTED_PUSAT', label:'Submit', isDisabled: true},
          {id:'REVISED_PUSAT', label:'Sudah Diperbaiki', isDisabled: true},
          {id:'REVIEW_PUSAT', label:'Sedang Diperiksa'},
          {id:'CORRECTION_PUSAT', label:'Perlu Perbaikan'},
          {id:'REJECTED_PUSAT', label:'Ditolak'},
          {id:'APPROVED_PUSAT', label:'Diterima'},
        ],
        pembinaDataPusatStatus:[
          {id:'DRAFT_PUSAT', label:'Draft', isDisabled: true},
          {id:'SUBMITTED_PUSAT', label:'Submit', isDisabled: true},
         {id:'REVISED_PUSAT', label:'Sudah Diperbaiki', isDisabled: true},
          {id:'REVIEW_PUSAT', label:'Sedang Diperiksa'},
          {id:'CORRECTION_PUSAT', label:'Perlu Perbaikan'},
          {id:'REJECTED_PUSAT', label:'Ditolak'},
          {id:'APPROVED_PUSAT', label:'Diterima'},
          {id:'PENDING_PUSAT', label:'Ditunda'},
          {id:'PUBLISHED_PUSAT', label:'Publish'},
        ],
        submissionPeriod:[],
        organization:[],
        division:[],
        province:[],
        city:[]
      }
    };
  },
  computed: {
    now(){
      return moment().format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    reviewHistories(){
      let sdsItem = this.sdsItem;
      let showedReviews = [];
      if(sdsItem){
        let allReview = sdsItem.sds_item_histories.filter(x=> !x.active && x.reviews && x.reviews.length>0).map(x=>x.reviews).flat();
        let currentReviewNotes = sdsItem.reviews ? sdsItem.reviews.map(x=>x.note) : [];

        
        allReview.forEach(x=>{
          if(!currentReviewNotes.includes(x.note)){
            showedReviews.push(x);
          }
        })
      }
      return showedReviews;
    },
    sdsTypeLabel(){
      return this.form.sds_type == 'INDICATOR' ? 'Indikator' : (this.form.sds_type == 'VARIABLE' ? 'Variabel' : 'Konsep & Definisi');
    },
    measurements(){
      return this.options.measurement.map(({id, name, description}) => ({id, name, description}));
    },
    variableMeasurementUnits(){
      if(this.variable && this.variable.measurement != null && this.options.measurement.lenght>0){
        return this.options.measurement.find(x => x.name == this.variable.measurement.name).measurement_units;
      }
      return  [];
    },
    indicatorMeasurementUnits(){
      if(this.indicator && this.indicator.measurement != null && this.options.measurement.lenght>0){
        return this.options.measurement.find(x => x.name == this.indicator.measurement.name).measurement_units;
      }
      return  [];
    },
    elementInfo(){
      let start = this.pagination.totalElements == 0 ? '0' : (this.pagination.currentPage-1)*this.pagination.pageSize+1; 
      let end = this.pagination.totalPages > 1 ? (this.pagination.currentPage)*this.pagination.pageSize : this.pagination.totalElements;
      return start + ' - ' + end+ ' approval';
    },
    startRowNumber(){
      return this.pagination.totalElements == 0 ? '0' : (this.pagination.currentPage-1)*this.pagination.pageSize+1; 
    },
    isSDNSPublished(){
      if(this.settingReleaseDate){
        return new Date() >= new Date(this.settingReleaseDate) ? true : false;
      }
      return false
    },
    status(){
      if(this.isAdmin){
        return this.options.adminStatus;
      }
      else if(this.isPembinaDataPusat){
        return this.options.pembinaDataPusatStatus;
      }
      else if(this.isWalidataPusat){
        return this.options.approverPusatStatus;
      }
      else if(this.isWalidataProvinsi || this.isPembinaDataProvinsi){
        return this.options.approverProvinsiStatus;
      }else{
        return this.options.approverKabupatenKotaStatus;
      }
    },
    field(){
      return this.form.sds_type == 'INDICATOR' ? this.options.indicator_fields: (this.form.sds_type == 'VARIABLE' ? this.options.variable_fields : this.options.concept_fields); 
    },
    isUpdate(){
      return this.form.submission_type ? (this.form.submission_type == 'UPDATE' ? true : false): false;
    },
    isRejected(){
      let status = this.form ? this.form.status : null;
      if(['REJECTED_KABKOTA','REJECTED_PROVINSI','REJECTED_PUSAT'].includes(status)){
        return true;
      }else{
        return false;
      }
    },
    isApproved(){
      let status = this.form ? this.form.status : null;
      return ['APPROVED_KABKOTA','APPROVED_PROVINSI','APPROVED_PUSAT'].includes(status) ? true : false;
    },
    isApprovedKabupatenKota(){
      let status = this.form ? this.form.status : null;
      return status == 'APPROVED_KABKOTA' ? true : false;
    },
    isApprovedProvinsi(){
      let status = this.form ? this.form.status : null;
      return status == 'APPROVED_PROVINSI' ? true : false;
    },
    isApprovedPusat(){
      let status = this.form ? this.form.status : null;
      return status == 'APPROVED_PUSAT' ? true : false;
    },
    isAdmin(){
      return this.userRoles.includes("ROLE_SDS_ADMIN")
    },
    isPembinaDataPusat(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PUSAT")
    },
    isPembinaDataProvinsi(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI")
    },
    isPembinaDataKabupatenKota(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI")
    },
    isWalidata(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT") || this.userRoles.includes("ROLE_SDS_WALIDATA_PROVINSI") || this.userRoles.includes("ROLE_SDS_WALIDATA_KABUPATEN_KOTA");
    },
    isWalidataPusat(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT");
    },
    isWalidataProvinsi(){
      return this.userRoles.includes("ROLE_WALIDATA_PROVINSI")
    },
    isWalidataKabupatenKota(){
      return this.userRoles.includes("ROLE_WALIDATA_KABKOTA")
    },
    isProdusenDataPusat(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT");
    },
    isProdusenDataProvinsi(){
      return this.userRoles.includes("ROLE_WALIDATA_PROVINSI")
    },
    isProdusenDataKabupatenKota(){
      return this.userRoles.includes("ROLE_WALIDATA_KABKOTA")
    },
    isProdusenData(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_PUSAT") || this.userRoles.includes("ROLE_PRODUSEN_DATA_PROVINSI") || this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
    },
    
    
  },
  watch:{
    'formFilter.name'(){
      this.filterSdsItemList();
    },
    'setting.sdsn.filter_text'(){
      this.filterSdsnList();
    }
  },
  async mounted() {
    this.sdsItemId = this.$route.params.id;
    this.getUserInfo(store.getters["auth/user"])
    this.setSubjectFieldsOptions();
    await Promise.all([
      this.setUpSetting(), 
      this.getUnitTypeList(),
      this.getMeasurementList(),
      this.getClassificationSeriesList(),
    ]);
    await this.getSdsItem();
    
    if(this.isAdmin||this.isWalidataProvinsi || this.isPembinaDataProvinsi){
      await this.getProvinsi()
      this.province = this.options.province.find(x=>x.code == this.user.organization.province.code)
    }
      
    if(this.form.sds_type != "CONCEPT"){
      await this.syncConceptReference();
    }
    if(this.form.sds_type == "INDICATOR"){
      await this.syncDisaggregationReference();
    }
    this.getSimilarSdsItem();
    this.getSdsnList();
  },
  methods: {
    async getSimilarSdsItem(){
       await sdsService.getSimilarSdsItem(this.sdsItemId).then(
        (result)=>{
          let items = result.data.result[0];
          items = items.filter(x => x.id != this.sdsItemId).map(x=>{
            x.selected = false;
            return x;
          });
          
          this.setting.similar_submission.items = items;
        },
        (error)=>{
          console.log(error);
        }
      );
    },
    async getSdsItem(){
      await sdsService.getSdsItem(this.sdsItemId).then(
        async (result)=>{
          this.sdsItem = {...result.data.result[0]};
          let x = this.sdsItem;
          this.form={
            data: x.data,
            submission_period: x.submission_period,
            submission_type: x.submission_type,
            sds_type: x.sds_type,
            status: x.status,
            rejection_note: x.rejection_note,
            alternative_sds_item_id: x.alternative_sds_item_id,
            rejected_similiar_item_ids:[],
            submitter: this.user,
            produsen_data: {
              id: x.produsen_data_id,
              name: x.produsen_data_name,
              province_code: x.produsen_data_province_code,
              city_code: x.produsen_data_city_code,
            },
            walidata_pusat: {
              id: x.walidata_pusat_id,
              name: x.walidata_pusat_name,
            },
            reviews:x.review ? x.review : [],
            proposed_walidata_kabupaten_kota:	false,
            proposed_walidata_provinsi:	false,
            proposed_walidata_pusat:	false,
          };
          this.produsenData = this.form.produsen_data;
          this.walidata = this.form.walidata_pusat; 
          
          if(this.form.sds_type == 'CONCEPT'){
            this.concept = this.form.submissionPeriod > 2022 ? this.form.data.concept : this.updateConceptStructure(this.form.data.concept, this.form.submission_type);
          }
          else if(this.form.sds_type == 'VARIABLE'){
            this.variable = this.form.submissionPeriod > 2022 ? this.form.data.variable : this.updateVariableStructure(this.form.data.variable, this.form.submission_type);
          }
          else{
            this.indicator = this.form.submissionPeriod > 2022 ? this.form.data.indicator : this.updateIndicatorStructure(this.form.data.indicator, this.form.submission_type);
          }
          if(['SUBMITTED_PUSAT','REVISED_PUSAT'].includes(this.sdsItem.status)){
            this.form.status = 'REVIEW_PUSAT'
          }
          if(['SUBMITTED_PROVINSI','REVISED_PROVINSI'].includes(this.sdsItem.status)){
            this.form.status = 'REVIEW_PROVINSI'
          }
          if(['SUBMITTED_KABKOTA','REVISED_KABKOTA'].includes(this.sdsItem.status)){
            this.form.status = 'REVIEW_KABKOTA'
          }
        },
        (error)=>{
          console.log(error);
        }
      );
    },
    async syncConceptReference(){
      if(this.form.sds_type == "VARIABLE"){
        let concepts = [...this.variable.concepts];
        this.variableConcepts  = [];
        for await(const item of concepts){
          let concept = null;
          if(this.sdsItem.submission_period==2022 && item.submission_id){
            let id = item.submission_id;
              await sdsService.getOldSdsItem(id).then(
              (result)=>{
                concept = {...result.data.result[0]};
                concept.definition = concept.data.concept.definition;
                concept.source = 'USULAN';
                
              },
              (error)=>{
                console.log(error);
              }
            );
          }else{
            await sdsService.getSdsItem(item.id).then(
              (result)=>{
                concept = {...result.data.result[0]};
                concept.definition = concept.data.concept.definition;
                concept.source = 'USULAN';
                
              },
              (error)=>{
                console.log(error);
              }
            );
          }
          this.variableConcepts.push(concept); 
        }
      }else{
        let concepts = [...this.indicator.concepts];
        this.indicatorConcepts  = [];
        for await(const item of concepts){
          let concept = null;
          if(this.sdsItem.submission_period==2022 && item.submission_id){
            let id = item.submission_id;
            await sdsService.getOldSdsItem(id).then(
              (result)=>{
                concept = {...result.data.result[0]};
                concept.definition = concept.data.concept.definition;
                concept.source = 'USULAN';
                
              },
              (error)=>{
                console.log(error);
              });
          }else{
            await sdsService.getSdsItem(item.id).then(
              (result)=>{
                concept = {...result.data.result[0]};
                concept.definition = concept.data.concept.definition;
                concept.source = 'USULAN';
                
              },
              (error)=>{
                console.log(error);
              });
          }
          this.indicatorConcepts.push(concept); 
        }
      }
      
    },
    async syncDisaggregationReference(){
      let disaggregations = [...this.sdsItem.data.indicator.disaggregations];
      this.indicatorDisaggregations  = [];
      for await(const item of disaggregations){
        let disaggregation = null;
        if(this.sdsItem.submission_period==2022 && item.submission_id){
          let id = item.submission_id;
          await sdsService.getOldSdsItem(id).then(
            (result)=>{
              disaggregation = {...result.data.result[0]};
              disaggregation.definition = disaggregation.data.variable.definition;
              disaggregation.source = 'USULAN';
              
            },
            (error)=>{
              console.log(error);
            }
          );
        }else{
          await sdsService.getSdsItem(item.id).then(
            (result)=>{
              disaggregation = {...result.data.result[0]};
              disaggregation.definition = disaggregation.data.variable.definition;
              disaggregation.source = 'USULAN';
              
            },
            (error)=>{
              console.log(error);
            }
          );
        }
        this.indicatorDisaggregations.push(disaggregation); 
      } 
      
    },
    updateConceptStructure(concept,submissionType){
      let newConcept = {
        code: concept.code,
        name: concept.name,
        definition: concept.definition,
        references: concept.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_concept: null,
      }
      if(submissionType == 'UPDATE'){
        newConcept.updated_concept = {
          changes_type : 'MODIFY', 
          items: []
        }
        if('updated_concept' in concept){
          newConcept.updated_concept = concept.updated_concept;
        }else{
          let newUpdatedConcept = concept.current_version;
          newUpdatedConcept.references = newUpdatedConcept.references.map(x=>x.name),
          
          newConcept.updated_concept = {
            changes_type : 'MODIFY', 
            items: [newUpdatedConcept]
          }
        }
      }
      return newConcept;
    },
    updateVariableStructure(variable,submissionType){
      // let submissionType = sdsItem.submission_type;
      // let variable = sdsItem.data.variable;
      // console.log(variable)
      let newVariable = {
        code: variable.code,
        name: variable.name,
        definition: variable.definition,
        concepts: ('concept' in variable) ? variable.concept : variable.concepts, //update with actual state,
        unit_types: variable.unit_types, //change format json
        measurement: variable.measurement, //change format json
        measurement_unit: variable.measurement_unit, //change format json,
        subject_field: variable.subject_field, //change format json,
        value_domain: variable.value_domain, //change format json
        rule: variable.rule,
        references: variable.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_variable: null,
      }
      if(submissionType == 'UPDATE'){
        if('updated_variable' in variable){
          newVariable.updated_variable = variable.updated_variable;
        }else{
          let newUpdatedVariable = variable.current_version;
          newUpdatedVariable.references = newUpdatedVariable.references.map(x=>typeof x == 'string' ? x : x.name);
          let newValueDomain  = {
            type: null,// change use current format
            classification_reference: null,
            items:[],
            total_levels:0
          }
          if('classification' in newUpdatedVariable.value_domain){
            newValueDomain.items = newUpdatedVariable.value_domain.classification.items;
          }else{
            newValueDomain.items = newUpdatedVariable.value_domain.items;
          }
          newUpdatedVariable.value_domain = newValueDomain;

          newVariable.updated_variable = {
            changes_type : 'MODIFY', 
            items: [newUpdatedVariable]
          }
        }

      }
      //change format json for unit types 
      if(newVariable.unit_types != null & newVariable.unit_types.length>0){
        newVariable.unit_types = newVariable.unit_types.filter(x=>x!=null).map(item => {
          if(item.id == null){
            let _newUnitTypes = {
              id:null,
              name:item.name,
              description:null,
            };
            return _newUnitTypes;
          }else{
            return this.options.unit_type.find(x => x.id == item.id);
          }        
        });
      }
      //change format json for measurement 
      if(newVariable.measurement){
        if(newVariable.measurement.id == null){
          let newMeasurement = {
            id:null,
            name:newVariable.measurement.name,
            description:null,
          };
          newVariable.measurement = newMeasurement;
        }else{
          newVariable.measurement = this.measurements.find(x => x.id == newVariable.measurement.id);
        }
      }
      //change format json for measurement unit
      if(newVariable.measurement_unit){
        if(newVariable.measurement_unit.id == null){
          let newMeasurementUnit = {
            id: null,
            name: newVariable.measurement_unit.name,
            symbol: null
          }
          newVariable.measurement_unit = newMeasurementUnit;
        }
        // else{
        //   newVariable.measurement_unit = this.variableMeasurementUnits.find(x => x.id == newVariable.measurement_unit.id);
        // }
      }
      //change format json for subject_field
      if(newVariable.subject_field){
        let subjects =  [...SubjectField]
        newVariable.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newVariable.subject_field.id);
      }
      //change format json for value domain
      // console.log(newVariable.value_domain)
      if(newVariable.value_domain){
        let newValueDomain  = {
          type: null,// change use current format
          classification_reference: null,
          items:[],
          total_levels:0
        }
        if(newVariable.value_domain.type && newVariable.value_domain.type.id != null){
          newValueDomain.type = this.options.value_domain_type.map(x=> x.value).find(x => x.id == newVariable.value_domain.type.id);
          if(newValueDomain.type.id == 76){
            if('classification' in newVariable.value_domain){
              newValueDomain.classification_reference = newVariable.value_domain.classification.id ? {
                id: newVariable.value_domain.classification.id,
                name: newVariable.value_domain.classification.name,
                description: null,
                used_type: newVariable.value_domain.classification.items.length>0 ? 'PARTIAL' : 'FULL',
              } : null;
              newValueDomain.items = newVariable.value_domain.classification.items;
            }else{
              newValueDomain.classification_reference = newVariable.value_domain.classification_reference;
              newValueDomain.items = newVariable.value_domain.items;
            }

            if(newValueDomain.classification_reference){
              //update classification reference
              this.classificationReferenceId = newValueDomain.classification_reference.id;
              this.classificationReferenceUsedType = newValueDomain.classification_reference.used_type;
            }
          }
        }
        newVariable.value_domain = newValueDomain;
      }
      return newVariable;
    },
    updateIndicatorStructure(indicator,submissionType){
      // let submissionType = sdsItem.submission_type;
      // let indicator = sdsItem.data.indicator;

      let newIndicator = {
        code: indicator.code,
        name: indicator.name,
        definition: indicator.definition,
        concepts: indicator.concepts, //update with actual state,
        measurement: indicator.measurement, //change format json
        measurement_unit: indicator.measurement_unit, //change format json,
        subject_field: indicator.subject_field, //change format json,
        benefit: indicator.benefit,
        interpretation: indicator.interpretation,
        presentation_levels: indicator.presentation_levels, //change format json,
        calculation_mechanism: indicator.calculation_mechanism,
        formula: indicator.formula,
        formula_structures: indicator.formula_structures,
        disaggregations: indicator.disaggregations, //update with actual state,
        references: indicator.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_indicator: null,
      }
      if(submissionType == 'UPDATE'){
        if('updated_indicator' in indicator){
          newIndicator.updated_indicator = indicator.updated_indicator;
        }else{
          let newUpdatedIndicator = indicator.current_version;
          newUpdatedIndicator.references = newUpdatedIndicator.references.map(x=>typeof x == 'string' ? x : x.name);
          newUpdatedIndicator.disaggregations = newUpdatedIndicator.disaggregations.map(x=>{
            x.references = []
            return x
          })
          newIndicator.updated_indicator = {
            changes_type : 'MODIFY', 
            items: [newUpdatedIndicator]
          }
        }
      }
      //change format json for measurement 
      if(newIndicator.measurement){
        if(newIndicator.measurement.id == null){
          let newMeasurement = {
            id:null,
            name: newIndicator.measurement.name,
            description:null,
          };
          newIndicator.measurement = newMeasurement;
        }else{
          newIndicator.measurement = this.measurements.find(x => x.id == newIndicator.measurement.id);
        }
      }
      //change format json for measurement unit
      if(newIndicator.measurement_unit){
        if(newIndicator.measurement_unit.id == null){
          let newMeasurementUnit = {
            id: null,
            name: newIndicator.measurement_unit.name,
            symbol: null
          } 
          newIndicator.measurement_unit = newMeasurementUnit;
        }
        // else{
        //   newIndicator.measurement_unit = this.indicatorMeasurementUnits.find(x => x.id == newIndicator.measurement_unit.id);
        // }
      }
      //change format json for subject_field
      if(newIndicator.subject_field){
        let subjects =  [...SubjectField]
        newIndicator.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newIndicator.subject_field.id);
      }
      //change format json for presentation levels
      if(newIndicator.presentation_levels != null & newIndicator.presentation_levels.length>0){
        //there is posibilty that there is a duplicate item, so we will remove it
        let unique = new Set();
        newIndicator.presentation_levels = newIndicator.presentation_levels.filter(obj => {
          let isPresent = unique.has(obj.id);
          unique.add(obj.id);
          return !isPresent;
        });
        
        newIndicator.presentation_levels = newIndicator.presentation_levels.map(item => {
          let z = this.options.presentation_level.map(x=> x.value).find(x => x.id == item.id);
          return z;
        });
      }
      
      return newIndicator;
    },
    async setUpSetting(){
      await sdsService.getSettings().then(
        (result)=>{
          // console.log(result)
          this.settiingSubmissionPeriod = result.data.body.filter(x=>x.property == 'submission_period')[0].value;
          this.settingReleaseDate = result.data.body.filter(x=>x.property == 'released_date')[0].value;
          this.form.submission_period = this.settiingSubmissionPeriod;
          this.options.submissionPeriod = [
            {
              id:this.settiingSubmissionPeriod,
              label:this.settiingSubmissionPeriod
            },
            {
              id:this.settiingSubmissionPeriod-1,
              label:this.settiingSubmissionPeriod-1
            }

          ]

          if(localStorage.submissionPeriod && localStorage.submissionPeriod == this.settiingSubmissionPeriod -1){
            this.submissionPeriod = localStorage.submissionPeriod;
          }
        },
        (error)=>{
          console.log(error)
        }
      )
    },
    async getReferences(){
      // await this.getProvinsi()
      // if(this.isAdmin||this.isWalidataProvinsi || this.isPembinaDataProvinsi){
      //   this.province = this.options.province.find(x=>x.code == this.user.organization.province.code)
      // }
      // // await this.getUnitTypeList();
      // this.getUnitTypeList();
      // await this.getMeasurementList();
      // await this.getClassificationSeriesList();
      // await this.setSubjectFieldsOptions();
      // this.setSubjectFieldsOptions();
      
    },
    async validateAllForm(){
      let valid = false;
      if(this.form.sds_type == 'CONCEPT'){
        valid = await this.$refs.conceptObserver.validate();
        valid = valid && await this.$refs.conceptReferencesObserver.validate();
      }else if(this.form.sds_type == 'VARIABLE'){
        valid = await this.$refs.variableObserver.validate();
        valid = valid && await this.$refs.variableReferencesObserver.validate();
        if(this.variable.value_domain.type.id==76 && this.variable.value_domain.classification_reference !=null && this.classificationReferenceUsedType=='PARTIAL'){
          if(this.variable.value_domain.items.length==0){
            valid = false
          }
          else{
            valid = valid && await this.$refs.valueDomainItemsObserver.validate();
          }
        }
      }else{
        valid = await this.$refs.indicatorObserver.validate();
        valid = valid && await this.$refs.indicatorReferencesObserver.validate();
        valid = valid && await this.$refs.formulaStructuresObserver.validate();
      }
      return valid;
    },
    async sendData(){
      this.form.data= {
        concept: null,
        variable: null,
        indicator:null,
      }
      if(this.form.sds_type == 'CONCEPT'){
        this.form.data.concept = this.concept;
      }else if(this.form.sds_type == 'VARIABLE'){
        if(this.variable.value_domain.type && this.variable.value_domain.type == 75){
          this.variable.value_domain.items = [];
          this.variable.value_domain.classification_reference=null;
        }
        this.form.data.variable = this.variable;
      }else{
        this.form.data.indicator = this.indicator;
      }
      if(this.isRejected){
        this.form.rejection_note = this.rejectionNote;
      }
      this.$bvModal.show('modal-saving');
      this.saveState = 'SAVING';

      await sdsService.approvalSdsItem(this.form,this.sdsItemId).then(
        (result) => {
          let response = result.data.result[0];
          if(response.status == 403 || response.status == 500){
            if(response.status == 403){
              this.modal.error.title = 'Forbidden';
              this.modal.error.description = 'Anda tidak mempunyai akses untuk menambahkan item';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.hide('modal-saving');
            this.$bvModal.show('modal-error');
          }else{
            this.saveState = 'SUCCESS';
            this.delay(2000).then(() => this.$router.push('/old-sds/daftar-pemeriksaan'));
          }
        },
        (error) => {
          this.saveState = 'ERROR';
          this.saveError = error.response;
        }
      );
    },
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
      this.form.submitter = this.user;
      
    },
    async getSdsnList(){
      this.setting.sdsn.isLoading = true;
      await sdsService.getSdsnListV2().then(
        (result)=>{
          let response = result.data;
          let sds_type = this.sdsItem.sds_type;
          let name =  sds_type == 'CONCEPT' ? this.concept.name : (sds_type == 'VARIABLE' ? this.variable.name: this.indicator.name);
          if(response.length>0){
            response = response.map(x=>{
              x.selected = false;
              x.similarity = this.similarityValue(x.konsep, name);
              return {...x};
            })
            response = response.sort((x, y) => {return y.similarity - x.similarity});
            this.setting.sdsn.items = [...response];
            this.setting.sdsn.filtered_items = [...response];
            this.setting.sdsn.pagination.totalPages = Math.round(response.length/this.setting.sdsn.pagination.pageSize);
            this.setting.sdsn.isLoading = false;
          }
        },
        (error) => {
            console.log(error);
            this.setting.sdsn.is_loading = false;
        }
        
      )
    },
    resetSortSdsn(){
      this.sortBy= [
        {
          property: "idSds",
          direction: null
        },
        {
          property: "noIndikator",
          direction: null
        },
        {
          property: "konsep",
          direction: null
        }
      ];
    },
    sortSdsn(sortOrder){
      if(sortOrder.direction == null){
        sortOrder.direction = "asc";
      }else if(sortOrder.direction == "asc"){
        sortOrder.direction = "desc";
      }else{
        sortOrder.direction = null;
      }
      this.getSdsnList()
    },
    goTo(link){
      this.$router.push(link);
    },
    
    checkPermission(status){
      if (this.roles.includes('ROLE_SUPERADMIN') || status == 'DRAFT') {
        return true;
      } else {
        return false;
      }
    },
    //step 1 function :list
    setSubjectFieldsOptions(){
      let subjects =  [...SubjectField]
      
      let lv1 = subjects.filter(x=> x.level == 1);
      let lv2 = subjects.filter(x=> x.level == 2);
      let lv3 = subjects.filter(x=> x.level == 3);

      lv2 = lv2.map(item => {
        let lv2_children = lv3.filter(x => x.parent == item.id).map(({id,code,name,description})=>({id,code,name,description}))
        item = { id: item.id, code: item.code, name: item.name, description: item.description, parent: item.parent }
        return lv2_children.length>0 ? {...item, ...{children: lv2_children}} : item;
      })
      lv1 = lv1.map(item => {
        let lv1_children = lv2.filter(x => x.parent == item.id).map(x=> {delete x.parent; return x});
        return { id: item.id, code: item.code,  name: item.name, description: item.description, children: lv1_children }
      })
      this.options.subject_fields = lv1;
    },
    //api function
    async getProvinsi(){
        await wilayahService.getProvinsi().then(
          (result) => {
              let options = result.data.data;
              this.options.province = options;
          },
          (error) => {
              this.error=error;
          }
        );
    },
    
    async getKabupatenKotaByIdProvinsi(){
        await wilayahService.getKabupatenKotaByIdProvinsi(this.province.id).then(
          (result) => {
              let options = result.data.data;
              this.options.city = options.map(x=>({id:x.kode, label:x.nama}))
          },
          (error) => {
              this.error=error;
          }
        );
    },
    
    async getUnitTypeList(){
      await mmsService.getUnitTypeList().then(
        (result) => {
          let response = result.data.result[0];
          this.options.unit_type = response;
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async getMeasurementList(){
      await mmsService.getMeasurementList().then(
        (result) => {
          let response = result.data.result[0];
          this.options.measurement = response;
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async getClassificationSeriesList(){
      await mmsService.getClassificationSeries('type=Classification&size=100').then(
        (result) => {
          let response = result.data.result[0].content;
          this.options.classification_series = response.map(x=>{
            return { 
                text: x.name + ' ('+x.abbreviation+')', 
                value: x.id,
                id: x.id,
                name:x.name,
                description:x.description,
              
            }
          });
          this.options.classification_series.push(
            {
              text: 'Tidak menggunakan', 
              value: null
            }
          );
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async getStatisticalClassificationByClassificationSeries(id){
      await mmsService.getStatisticalClassificationByClassificationSeries(id).then(
        (result) => {
          let response = result.data.result[0].content;
          this.options.statistical_classification  = response;
          
        },
        (error) => {
          this.error=error;
        }
      );
    },
    keyValueFormatter(keyValues){
      let result = keyValues.map(record => {
        let row = {id:record.id};
        record.attributes.forEach(attribute => {
          let column = {[attribute.en_name.replace(/ /g,"_")]:attribute.value}
          row = {...row,...column};
        })
        return row;
      });
      return result;
    },
    //step 2 function :form
    addNewUnitType(new_unit_type){
      let new_item = {
        id: null,
        name: new_unit_type,
        description:null,
      }
      this.options.unit_type.push(new_item)
      this.variable.unit_types.push(new_item)
    },
    addNewVariableMeasurement(new_measurement_name){
      let new_measurement = {
        id:null,
        name:new_measurement_name,
        description:null,
      };
      this.options.measurement.push({...new_measurement,...{measurement_units:[]}});
      this.variable.measurement = new_measurement;
      this.variable.measurement_unit = null;
    },
    addNewVariableMeasurementUnit(new_measurement_unit_name){
      let new_measurement_unit = {
        id: null,
        name: new_measurement_unit_name,
        symbol: null
      } 
      this.options.measurement.forEach(x => {
        if(x.name == this.variable.measurement.name){
          x.measurement_units.push(new_measurement_unit)
        }
      });
      this.variable.measurement_unit = new_measurement_unit;
    },
    
    addNewIndicatorMeasurement(new_measurement_name){
      let new_measurement = {
        id: null,
        name: new_measurement_name,
        description: null,
      };
      this.options.measurement.push({...new_measurement,...{measurement_units:[]}});
      this.indicator.measurement = new_measurement;
      this.indicator.measurement_unit = null;
    },
    addNewIndicatorMeasurementUnit(new_measurement_unit_name){
      let new_measurement_unit = {
        id: null,
        name: new_measurement_unit_name,
        symbol: null
      } 
      this.options.measurement.forEach(x => {
        if(x.name == this.indicator.measurement.name){
          x.measurement_units.push(new_measurement_unit)
        }
      });
      this.indicator.measurement_unit = new_measurement_unit;
    },
    indicatorPresentationLevelChanged(){
      let presentation_levels = [...this.indicator.presentation_levels];
      let provExisted = presentation_levels.filter(x =>x.id == 149).length>0 ? true : false;
      if(provExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null}
        ]
      }

      let kabExisted = presentation_levels.filter(x =>x.id == 150).length>0 ? true : false;
      if(kabExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null},
          { id: 150, name: 'Kabupaten/Kota', description: null},
        ]
      }

      let kecExisted = presentation_levels.filter(x =>x.id == 151).length>0 ? true : false;
      if(kecExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null},
          { id: 150, name: 'Kabupaten/Kota', description: null},
          { id: 151, name: 'Kecamatan', description: null},
        ]
      }

      let kelExisted = presentation_levels.filter(x =>x.id == 152).length>0 ? true : false;
      if(kelExisted){
        this.indicator.presentation_levels = [
          { id: 148, name: 'Nasional', description: null},
          { id: 149, name: 'Provinsi', description: null},
          { id: 150, name: 'Kabupaten/Kota', description: null},
          { id: 151, name: 'Kecamatan', description: null},
          { id: 152, name: 'Kelurahan/Desa', description: null}
        ]
      }
    },
    valueDomainTypeChanged(){
      if(this.variable.value_domain.type.id == 76 && this.variable.value_domain.items.length == 0){
        this.variable.value_domain.items.push(new ValueDomainItem());
      }
    },
    valueDomainClassificationReferenceChanged(){
      this.variable.value_domain.items=[];
      if(this.variable.value_domain.classification_reference){
        this.classificationReferenceUsedType= 'FULL'
      }else{
        this.variable.value_domain.items.push(new ValueDomainItem());
      }      
    },
    classificationReferenceUsedTypeChanged(){
      this.variable.value_domain.classification_reference.used_type = this.classificationReferenceUsedType;
      this.variable.value_domain.items=[];
      if(this.classificationReferenceUsedType == 'FULL'){
        this.variable.value_domain.items=[];
      }
    },
    showModalValueDomain(classificationSeriesId){
      this.getStatisticalClassificationByClassificationSeries(classificationSeriesId)
      this.$bvModal.show('modal-value-domain');
    },
    async searchValueDomainItems(){
      let statClassId = this.modal.valueDomain.statClass.id;
      let levelId = this.modal.valueDomain.level.id;
      let name = this.modal.valueDomain.name;
      this.modal.valueDomain.table.items=[];
      this.modal.valueDomain.table.isLoading=true;
      let page = this.modal.valueDomain.table.pagination.currentPage-1;
      let size = this.modal.valueDomain.table.pagination.pageSize;
      await mmsService.getStatisticalClassificationItems(statClassId, levelId, null, name, page, size).then(
        (result) => {
          let response = result.data.result[0];
          this.modal.valueDomain.table.items = response.content.map(item => ({...item, selected: false}));
          this.modal.valueDomain.table.pagination.totalPages = response.total_pages;
          this.modal.valueDomain.table.pagination.totalElements= response.total_elements;
          
        },
        (error) => {
          this.error=error;
        }
      );
      this.modal.valueDomain.table.isLoading=false;
    },
    saveItemAsValueDomain(){
      this.modal.valueDomain.table.items.filter(x=>x.selected==true).forEach(x=>{
        let newItem = {
          id: x.id,
          code:x.code,
          name: x.name,
          description: x.description,
          parent: x.parent_id ? {
            id:x.parent_id,
            code:null
          } : null,
        }
        this.variable.value_domain.items.push(newItem);
      })
      this.$bvModal.hide('modal-value-domain')
      
    },
    async addNewVariableValueDomain(){
      let newItem = {
        id: null,
        code: null,
        name: null,
        description: null,
        parent:{
          id: null,
          code: null
        }
      }
      if(this.variable.value_domain.items.length>0){
        let valid = await this.$refs.valueDomainItemsObserver.validate();
        if(valid){
          this.variable.value_domain.items.push(newItem);
        }
      }else{
        this.variable.value_domain.items.push(newItem);
      }
    },
    deleteVariableValueDomain(deletedIndex){
       this.variable.value_domain.items =  this.variable.value_domain.items
        .filter((items,index) => index != deletedIndex);
    },
    deleteIndicatorConcept(deletedIndex){
      this.indicator.concepts = this.indicator.concepts
        .filter((items,index) => index != deletedIndex);
    },
    deleteIndicatorDisagregation(deletedIndex){
      this.indicator.disaggregations = this.indicator.disaggregations
        .filter((items,index) => index != deletedIndex);
    },
    async addFormulaStructure(){
      let valid = await this.$refs.formulaStructuresObserver.validate();
      if(valid){
        this.indicator.formula_structures.push({symbol:null,description:null});
      }
    },
    deleteFormulaStructure(deletedIndex){
      this.indicator.formula_structures = this.indicator.formula_structures
        .filter((items,index) => index != deletedIndex);
    },
    async addConceptReference(){
      if(this.concept.references.length>0){
        let valid = await this.$refs.conceptReferencesObserver.validate();
        if(valid){
          this.concept.references.push('');
        }
      }
      else{
        this.concept.references.push('');
      }
    },
    deleteConceptReference(deletedIndex){
      this.concept.references = this.concept.references
        .filter((items,index) => index != deletedIndex);
    },
    async addVariableReference(){
      if(this.variable.references.length>0){
        let valid = await this.$refs.variableReferencesObserver.validate();
        if(valid){
          this.variable.references.push('');
        }
      }
      else{
        this.variable.references.push('');
      }
    },
    deleteVariableReference(deletedIndex){
      this.variable.references = this.variable.references
        .filter((items,index) => index != deletedIndex);
    },
    async addIndicatorReference(){
      if(this.indicator.references.length>0){
        let valid = await this.$refs.indicatorReferencesObserver.validate();
        if(valid){
          this.indicator.references.push('');
        }
      }
      else{
        this.indicator.references.push('');
      }
    },
    deleteIndicatorReference(deletedIndex){
      this.indicator.references = this.indicator.references
        .filter((items,index) => index != deletedIndex);
    },
    //utility function
    handlePageChange(){
      this.getSdsnList();        
    },
    listFormatter(value){
      if(value){
        let formattedList = '<div class="text-left">';
        value.split(';').forEach((item,index) => {
          formattedList = formattedList + '<div class="d-flex"><div>'+(index+1)+'.&nbsp;</div><div>'+item+'</div></div>';
        });
        return formattedList + '</div>';
      }else{
        return '-';
      }
    },
    dateFormatter(stringDate){
      moment.locale("id");
      return moment(stringDate).format('LL');
    },
    statusFormatter(status){
      return status ? this.options.status.find(x=>x.value == status).label : 'Draft';
    },
    statusFormatterStyle(status){
      return status ? status.split('_')[0].toLowerCase() : 'draft';
    },
    //loadoptions
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    async produsenDataLoadOptions({searchQuery, callback}){
      let provinceCode = this.provinsi ? this.provinsi.code : null; 
      let cityCode = this.city ? this.city.code : null; 
      await organizationService.getOrganizationByWilayah(searchQuery, provinceCode, cityCode ).then(
        (result) => {
          let options = result.data.content;
          callback(null, options)
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async walidataLoadOptions({searchQuery, callback}){
      // let cityCode = this.city ? this.city : this.province.code + '00'; 
      await organizationService.getOrganizationByWilayah(searchQuery, null, null).then(
        (result) => {
          let options = result.data.content;
          callback(null, options)
        },
        (error) => {
          this.error=error;
        }
      );
    },
    async conceptReferenceLoadOptions({searchQuery, callback}){
        await sdsService.getConceptReferenceList(searchQuery).then(
          (result) => {
              let options = result.data.result[0].content;
              callback(null, options)
          },
          (error) => {
              this.error=error;
          }
        );
    },
    async variableReferenceLoadOptions({searchQuery, callback}){
        await sdsService.getVariableReferenceList(searchQuery).then(
          (result) => {
              let options = result.data.result[0].content;
              callback(null, options)
          },
          (error) => {
              this.error=error;
          }
        );
    },
    async alternativeSdsItemLoadOptions({searchQuery, callback}){
      let status = 'APPROVED_PUSAT';
      let query = "&name="+searchQuery+"&sdsType="+this.form.sds_type;
      if(this.isWalidataPusat){
        query += "&walidataPusatId="+this.user.organization.id;
      }
      if(this.isWalidataProvinsi || this.isPembinaDataProvinsi){
        status = 'APPROVED_PROVINSI';
        query += "&produsenDataProvinceCode="+this.user.organization.province.code;
      }
      if(this.isWalidataKabupatenKota || this.isPembinaDataKabupatenKota){
        status = 'APPROVED_KABKOTA';
        query += "&produsenDataProvinceCode="+this.user.organization.province.code;
        query += "&produsenDataCityCode="+this.user.organization.city.code;
      }
      if(this.rejectionNote.type =='SIMILAR_SDSN_ALREADY_EXISTS'){
        status = 'PUBLISHED';
      }
      query += "&status="+status;
      await sdsService.getSdsItemListByQuery(query).then(
        (result)=>{
          let options = result.data.content;
          callback(null, options)
        },
        (error)=>{
          console.log(error)
        }
      )
      if(this.form.rejected_status_type){
        let id = 'USULAN-'+this.sdsItemId
        let options = null ;
        let status = this.form.rejected_status_type;
        if(this.form.sds_type == 'CONCEPT'){
          options = this.options.concept.filter(x => x.id != id && (x.status == 'APPROVED' || x.status == 'PUBLISHED'))
        }
        else if(this.form.sds_type == 'VARIABLE'){
          options = this.options.variable.filter(x => x.id != id && (x.status == 'APPROVED' || x.status == 'PUBLISHED'))
        }
        else{
          options = this.options.indicator.filter(x => x.id != id && (x.status == 'APPROVED' || x.status == 'PUBLISHED'))
        }
        return status == 'SIMILAR_SDSN_ALREADY_EXISTS' ? options.filter(x=>x.source == 'SDSN') : options.filter(x=>x.source == 'USULAN') 
      }else{
        return null;
      }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    provinceNormalizer(node){
      return {
        id: node.id,
        label: node.name,
      }
    },
    organizationNormalizer(node) {
      return {
        id: node.id,
        label: node.instansi ? node.instansi : node.name,
      }
    },
    produsenDataNormalizer(node) {
      return {
        id: node.id,
        label: node.instansi ? node.instansi : node.name,
      }
    },
    conceptNormalizer(node) {
      return {
        id: node.id != null ? node.id : node.submission_id ,
        label: node.name,
      }
    },
    variableNormalizer(node) {
      return {
        id: node.id != null ? node.id : node.submission_id ,
        label: node.name,
      }
    },
    itemExist(name, objectArray){
      if(objectArray != null){
        let existItem = objectArray.filter(x => x.name == name);
        return existItem.length>0 ? true:false;
      }
      else{
        return false
      }
    },
    rejectedStatusTypeFormatter(status){
      return status ? this.options.rejected_status_type.find(x=>x.id == status).label : null;
    },
    
    produsenDataChanged(){
      let x =  this.produsenData
      this.form.produsen_data = {
        id: x.id,
        name: x.instansi ? x.instansi : x.name,
        province_code: x.idProvinsi ? x.idProvinsi : x.province_code,
        city_code :x.idKabupatenKota ? x.idKabupatenKota : x.city_code,
      }
    },
    walidataChanged(){
      let org = this.walidata;
      this.form.walidata_pusat = {
        id:org.id,
        name: org.instansi,
      }
    },
    variableConceptsChanged(){
      this.variable.concepts = this.variableConcepts.map(x=>{
        if(isNaN(x.id)){
          return {id:parseInt(x.id.split('-')[1]),name:x.name,source:x.source}
        }else{
          return {id:x.id,name:x.name,source:x.source}
        }
      })
    },
    indicatorConceptsChanged(){
      this.indicator.concepts = this.indicatorConcepts.map(x=>{
        if(isNaN(x.id)){
          return {id:parseInt(x.id.split('-')[1]),name:x.name,source:x.source}
        }else{
          return {id:x.id,name:x.name,source:x.source}
        }
      })
    },
    indicatorDisaggregationsChanged(){
      this.indicator.disaggregations = this.indicatorDisaggregations.map(x=>{
        if(isNaN(x.id)){
          return {id:parseInt(x.id.split('-')[1]),name:x.name,source:x.source}
        }else{
          return {id:x.id,name:x.name,source:x.source}
        }
      })
    },
    //SETTING MODAL FUNCTION
    //1. SUBMISSION TYPE MODAL (NEW OR UPDATE)
    showUpdatingSubmissionTypeModal(){

      this.setting.submission_type = this.form.submission_type;
      this.setting.sdsn.filter_text = null;
      let updatedItems = [];
      if(this.form.submission_type == 'UPDATE'){
        if(this.form.sds_type == 'CONCEPT'){
          updatedItems = this.concept.updated_concept.items;
        }else if(this.form.sds_type == 'VARIABLE'){
          updatedItems = this.variable.updated_variable.items;
        }else{
          updatedItems = this.indicator.updated_indicator.items;
        }
      }
      this.setting.sdsn.selected_ids = updatedItems.map(x=>x.id);
      this.setting.sdsn.filtered_items = this.setting.sdsn.items.map(x => ({...x}));
      this.sortSdsnList();
      this.$bvModal.show('modal-submission-type');
    },
    filterSdsnList(){
      let filter_text = this.setting.sdsn.filter_text;
      let field = this.setting.sdsn.selected_filter_field.id;
      let items = this.setting.sdsn.items.map(x => ({...x}));
      let filtered_items = [];
      if(filter_text){
        filter_text = filter_text.trim().toLowerCase();
        if(field == 'idSds'){
          filtered_items = items.filter(x=> x.idSds.trim().toLowerCase().indexOf(filter_text) !== -1);
        }
        if(field == 'noIndikator'){
          filtered_items = items.filter(x=> x.noIndikator.trim().toLowerCase().indexOf(filter_text) !== -1);
        }
        if(field == 'konsep'){
          filtered_items = items.filter(x=> x.konsep.trim().toLowerCase().indexOf(filter_text) !== -1)
                                .sort((x,y) => x.konsep.length - y.konsep.length);
        }
        if(field == 'definisi'){
          filtered_items = items.filter(x=> x.definisi.trim().toLowerCase().indexOf(filter_text) !== -1);
        }
        if(field == 'klasifikasi'){
          filtered_items = items.filter(x=> x.klasifikasi.trim().toLowerCase().indexOf(filter_text) !== -1);
        }
        if(field == 'ukuran'){
          filtered_items = items.filter(x=> x.ukuran.trim().toLowerCase().indexOf(filter_text) !== -1);
        }
        if(field == 'satuan'){
          filtered_items = items.filter(x=> x.satuan.trim().toLowerCase().indexOf(filter_text) !== -1);
        }
        this.setting.sdsn.filtered_items = filtered_items;
      }else{
        this.setting.sdsn.filtered_items = items;
      }
      this.sortSdsnList();
    },
    sortSdsnList(){
      let selectedIds = this.setting.sdsn.selected_ids;
      let selectedItems = this.setting.sdsn.items.filter(x=> selectedIds.includes(x.id)).map(x => {
        let y = {...x}
        y.selected = true;
        return y;
      }).sort((x,y)=> y.similarity - x.similarity);

      let unselectedItems = this.setting.sdsn.filtered_items.filter(x=> !selectedIds.includes(x.id)).map(x => {
        let y = {...x}
        y.selected = false;
        return y;
      }).sort((x,y)=> y.similarity - x.similarity);
      this.setting.sdsn.filtered_items = [...selectedItems,...unselectedItems];
    },
    sdsnSelected(selected, sdsnId){
      
      if(selected){
        this.setting.sdsn.selected_ids.push(sdsnId);
        this.sortSdsnList();
      }else{
        this.setting.sdsn.selected_ids = this.setting.sdsn.selected_ids.filter(x => x != sdsnId)
        this.filterSdsnList()
      }
      
    },
    sdsnFormatter(sdsn){
      // console.log(sdsn);
      let item = null;
      if(this.form.sds_type == 'CONCEPT'){
        item = {
          id: sdsn.id,
          code: sdsn.idSds,
          name: sdsn.konsep,
          definition: sdsn.definisi,
          references: sdsn.sumberContent ? [sdsn.sumberContent] : [],
        }
      }else if(this.form.sds_type == 'VARIABLE'){
        item = {
          id: sdsn.id,
          code: sdsn.idSds,
          name: sdsn.konsep,
          definition: sdsn.definisi,
          concepts: [],
          unit_types: [],
          measurement: {
            id: null,
            name: sdsn.ukuran,
            description: null,
          },
          measurement_unit: {
            id: null,
            symbol: null,
            name: sdsn.satuan,
          },
          subject_field: null,
          value_domain: {
            type: null,
            classification_reference: null,
            items: [
              {
                id: null,
                code: null,
                name: sdsn.klasifikasi,
                description: null,
                parent:null,
              }
            ],
            total_levels:null,
          },
          rule: null,
          references: sdsn.sumberContent ? [sdsn.sumberContent] : [],
        }
      }else{
        item = {
          id: sdsn.id,
          code: sdsn.idSds,
          name: sdsn.konsep,
          definition: sdsn.definisi,
          concepts: [],
          measurement: {
            id: null,
            name: sdsn.ukuran,
            description: null,
          },
          measurement_unit: {
            id: null,
            symbol: null,
            name: sdsn.satuan,
          },
          subject_field: null,
          benefit: null,
          interpretation: null,
          presentation_levels: [],
          calculation_mechanism: null,
          formula: null,
          formula_structures: [],
          disaggregations: [
            {
              id: null,
              code: null,
              name: sdsn.klasifikasi,
              definition: null,
              concepts: [],
              unit_types: [],
              measurement: null,
              measurement_unit: null,
              subject_field: null,
              value_domain: null,
              rule: null,
              references: [],
            }
          ],
          references: sdsn.sumberContent ? [sdsn.sumberContent] : [],
        };
      }
      return item;
    },
    saveUpdatingSubmissionTypeModal(){
      let currentSdsType = this.form.sds_type;
      let newSubmissionType = this.setting.submission_type;

      this.form.submission_type = newSubmissionType;

      if(this.form.submission_type == 'UPDATE'){
        let updatedItems = []
        this.setting.sdsn.items.filter(x=> this.setting.sdsn.selected_ids.includes(x.id)).forEach(x => {
          updatedItems.push(this.sdsnFormatter(x))
        })
        if(currentSdsType == 'CONCEPT'){
          this.concept.updated_concept = {
            changes_type : this.setting.submission_changes_type,
            items: updatedItems
          };
        }else if(currentSdsType == 'VARIABLE'){
          this.variable.updated_variable = {
            changes_type : this.setting.submission_changes_type,
            items: updatedItems
          };
        }else{
          this.indicator.updated_indicator = {
            changes_type : this.setting.submission_changes_type,
            items: updatedItems
          };
        }
      }
      //submissionType == 'NEW'
      else{
        this.setting.sdsn.selected_ids = [];
        this.setting.sdsn.filtered_items = [...this.setting.sdsn.items];
        if(currentSdsType == 'CONCEPT'){
          this.concept.updated_concept = null;
        }else if(currentSdsType == 'VARIABLE'){
          this.variable.updated_variable = null;
        }else{
          this.indicator.updated_indicator = null;
        }
      }
      this.$bvModal.hide('modal-submission-type');
    },
    
    //2. SDS TYPE
    showUpdatingSdsTypeModal(){
      this.setting.sds_type = this.form.sds_type;
      this.$bvModal.show('modal-sds-type');
    },
    saveUpdatingSdsTypeModal(){
      let submissionType = this.form.submission_type;
      let oldSdsType = this.form.sds_type;
      let newSdsType = this.setting.sds_type;
      if(oldSdsType != newSdsType){
        //do something
        if(newSdsType == 'CONCEPT'){
          if(oldSdsType == 'VARIABLE'){
            this.concept = {
              code: null,
              name: this.variable.name,
              definition: this.variable.definition,
              references: this.variable.references,
              updated_concept: null
            }
            if(submissionType == 'UPDATE'){
              this.concept.updated_concept = {
                changes_type : this.variable.updated_variable.changes_type, 
                items: this.variable.updated_variable.items.map(x=>{
                  return {
                    id: x.id,
                    code: x.code,
                    name: x.name,
                    definition: x.definition,
                    references: x.references,
                  }
                }), 
              }
            }
          }
          if(oldSdsType == 'INDICATOR'){
            this.concept = {
              code: null,
              name: this.indicator.name,
              definition: this.indicator.definition,
              references: this.indicator.references,
              updated_concept: null
            }
            if(submissionType == 'UPDATE'){
              this.concept.updated_concept = {
                changes_type : this.indicator.updated_indicator.changes_type, 
                items: this.indicator.updated_indicator.items.map(x=>{
                  return {
                    id: x.id,
                    code: x.code,
                    name: x.name,
                    definition: x.definition,
                    references: x.references,
                  }
                }), 
              }
            }
          }
          this.variable = null;
          this.indicator = null;
            
        }
        else if(newSdsType == 'VARIABLE'){
          if(oldSdsType == 'CONCEPT'){
            this.variable = {
              code: null,
              name: this.concept.name,
              definition: this.concept.definition,
              concepts: [],
              unit_types: [],
              measurement: null,
              measurement_unit: null,
              subject_field: null,
              value_domain: new ValueDomain(),
              rule: null,
              references: this.concept.references,
              updated_variable: null
            }
            if(submissionType == 'UPDATE'){
              this.variable.updated_variable = {
                changes_type : this.concept.updated_concept.changes_type, 
                items: this.concept.updated_concept.items.map(x=>{
                  return {
                    id: x.id,
                    code: x.code,
                    name: x.name,
                    definition: x.definition,
                    concepts: [],
                    unit_types: [],
                    measurement: null,
                    measurement_unit: null,
                    subject_field: null,
                    value_domain: new ValueDomain(),
                    rule: null,
                    references: x.references,
                  }
                })
              }
            }
          }
          if(oldSdsType == 'INDICATOR'){
            this.variable = {
              code: null,
              name: this.indicator.name,
              definition: this.indicator.definition,
              concepts: this.indicator.concepts,
              unit_types: [],
              measurement: this.indicator.measurement,
              measurement_unit: this.indicator.measurement_unit,
              subject_field: this.indicator.subject_field,
              value_domain: new ValueDomain(),
              rule: null,
              references: this.indicator.references,
              updated_variable: null
            }
            if(submissionType == 'UPDATE'){
              this.variable.updated_variable = {
                changes_type : this.indicator.updated_indicator.changes_type, 
                items: this.indicator.updated_indicator.items.map(x=>{
                  return {
                    id: x.id,
                    code: x.code,
                    name: x.name,
                    definition: x.definition,
                    concepts: x.concepts,
                    unit_types: [],
                    measurement: x.measurement,
                    measurement_unit: x.measurement_unit,
                    subject_field: x.subject_field,
                    value_domain: new ValueDomain(),
                    rule: null,
                    references: x.references,
                  }
                })
              }
            }
            
          }
          this.concept = null;
          this.indicator = null;
        }else{
          if(oldSdsType == 'CONCEPT'){
            this.indicator = {
              code: null,
              name: this.concept.name,
              definition: this.concept.definition,
              concepts: [],
              measurement: null,
              measurement_unit: null,
              subject_field: null,
              benefit: null,
              interpretation: null,
              presentation_levels: [],
              calculation_mechanism: null,
              formula: null,
              formula_structures: [],
              disaggregations: [],
              references: this.concept.references,
              updated_indicator: null
            }
            if(submissionType == 'UPDATE'){
              this.indicator.updated_indicator = {
                changes_type : this.concept.updated_concept.changes_type,
                items: this.concept.updated_concept.items.map(x=>{
                  return{
                    id: x.id,
                    code: x.code,
                    name: x.name,
                    definition: x.definition,
                    concepts: [],
                    measurement: null,
                    measurement_unit: null,
                    subject_field:null,
                    benefit: null,
                    interpretation: null,
                    presentation_levels: [],
                    calculation_mechanism: null,
                    formula: null,
                    formula_structures: [],
                    disaggregations: [],
                    references: x.references,
                  }
                })
              }
            }
          }
          if(oldSdsType == 'VARIABLE'){
            this.indicator = {
              code: null,
              name: this.variable.name,
              definition: this.variable.definition,
              concepts: this.variable.concepts,
              measurement: this.variable.measurement,
              measurement_unit: this.variable.measurement_unit,
              subject_field: this.variable.subject_field,
              benefit: null,
              interpretation: null,
              presentation_levels: [],
              calculation_mechanism: null,
              formula: null,
              formula_structures: [],
              disaggregations: [],
              references: this.variable.references,
              updated_indicator: null
              
            }
            if(submissionType == 'UPDATE'){
              this.indicator.updated_indicator = {
                changes_type : this.variable.updated_variable.changes_type, 
                items: this.variable.updated_variable.items.map(x=>{
                  return{
                    id: x.id,
                    code: x.code,
                    name: x.name,
                    definition: x.definition,
                    concepts: x.concepts,
                    measurement: x.measurement,
                    measurement_unit: x.measurement_unit,
                    subject_field: x.subject_field,
                    benefit: null,
                    interpretation: null,
                    presentation_levels: [],
                    calculation_mechanism: null,
                    formula: null,
                    formula_structures: [],
                    disaggregations: [],
                    references: x.references,
                  }
                })
              }
            }
          }
          this.concept = null;
          this.variable = null;
        }
        this.form.sds_type = newSdsType
        this.similarSdsItems = [];
        this.setting.similar_submission.selected_ids = [];
      }
      this.$bvModal.hide('modal-sds-type');
    },
    //3. SIMILAR SUBMISSION
    showSimilarSubmissionModal(){
      let existIds = this.similarSdsItems.map(x=>x.id);
      this.setting.similar_submission.items.forEach(x=>{
        if(existIds.includes(x.id)){
          x.selected = true;
        }else{
          x.selected = false;
        }
      })
      this.$bvModal.show('modal-similar-item');
    },
    sortSimilarSubmissionList(){
      let selectedItems = this.setting.similar_submission.filtered_items
                              .filter(x=> x.selected == true)
                              .sort((x,y)=> y.similarity - x.similarity);

      let unselectedItems = this.setting.similar_submission.filtered_items
                                .filter(x=> x.selected != true)
                                .sort((x,y)=> y.similarity - x.similarity);
      this.setting.similar_submission.filtered_items = [...selectedItems,...unselectedItems];
    },
    
    filterSimilarSubmissions(){
      
      let filtered_name = this.setting.similar_submission.filtered_name;
      let items = [...this.setting.similar_submission.items];
      if(filtered_name){
        filtered_name = filtered_name.trim().toLowerCase();
        this.setting.similar_submission.filtered_items = items.filter(x=>  x.name.trim().toLowerCase().indexOf(filtered_name) !== -1);
      }else{
        console.log("empty")
        this.setting.similar_submission.filtered_items = items;
      }
    },
    
    async showSaveModal(){
      let valid = await this.validateAllForm();
      if(valid){
        this.$bvModal.show('modal-save-submission');
      }else{
        this.modal.error.title = 'Isian Error';
        this.modal.error.description = 'Pastikan Semua isian sudah dalam keadaan valid';
        this.$bvModal.show('modal-error');
      }
      
    },

    AddReview(){
      let review = {...this.review}
      review.created_at = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
      this.form.reviews.push(review);
    },
    
    async saveSimilarSdsItem(){
      //cek apakah ada item yang baru ditambahkan
      let existIds = this.similarSdsItems.map(x=>x.id);
      let newSimilarItems = this.setting.similar_submission.items.filter(x=> x.selected == true);
      let newSimilarItemIds = newSimilarItems.filter(x=> x.selected == true).map(x=>x.id);
      newSimilarItems.forEach(async x=>{
        if(!existIds.includes(x.id)){
          if(x.submission_period == 2022){
            if(this.form.sds_type == 'CONCEPT'){
              x.data.concept = this.updateConceptStructure(x.data.concept, this.form.submission_type);
            }
            else if(this.form.sds_type == 'VARIABLE'){
              x.data.variable = this.updateVariableStructure(x.data.variable, this.form.submission_type);
            }
            else{
              x.data.indicator = this.updateIndicatorStructure(x.data.indicator, this.form.submission_type);
            }
          }
          this.similarSdsItems.push(x);
          this.setting.similar_submission.selected_ids.push(x.id);
        }
      });
      // cek apakah ada yg dihapus
      this.similarSdsItems = this.similarSdsItems.filter(x => newSimilarItemIds.includes(x.id));
      this.setting.similar_submission.selected_ids = this.setting.similar_submission.selected_ids.filter(x => newSimilarItemIds.includes(x.id));
      this.$bvModal.hide('modal-similar-item');
    },
    

    similarityValue(text1,text2){
      if(text1 != null && text2 != null){
        return text1 && text2 ? (stringSimilarity.compareTwoStrings(text1,text2 )*100).toFixed(0) : 0;
      }
      else if(text1 == null && text2 == null){
        return 100;
      }else{
        return 0;
      }
    },
    similarity(text1,text2){
      if(text1 != null && text2 != null){
        return text1 && text2 ? (stringSimilarity.compareTwoStrings(text1,text2 )*100).toFixed(0) + '%' : '0%';
      }
      else if(text1 == null && text2 == null){
        return '100%'
      }else{
        return '0%'
      }
    },
    referencesSimilarity(array1,array2){
      let string1 = array1.join(' ');
      let string2 = array2.join(' ');
      return (stringSimilarity.compareTwoStrings(string1,string2)*100).toFixed(0) + '%';
    },
    conceptsSimilarity(array1, array2){
      let string1 = array1.length > 0 ? array1.map(x=>x.name).join(' ') : null;
      let string2 = array2.length > 0 ? array2.map(x=>x.name).join(' ') : null;
      return string1 && string2 ? (stringSimilarity.compareTwoStrings(string1,string2)*100).toFixed(0) + '%' : '0%';
    },
    unitTypesSimilarity(array1, array2){
      let string1 = array1.length > 0 ? array1.map(x=>x.name).join(' ') : null;
      let string2 = array2.length > 0 ? array2.map(x=>x.name).join(' ') : null;
     return string1 && string2 ? (stringSimilarity.compareTwoStrings(string1,string2)*100).toFixed(0) + '%' : '0%';
    },
    levelsSimilarity(array1,array2){
      let string1 = array1.join(' ');
      let string2 = array2.join(' ');
       return string1 && string2 ? (stringSimilarity.compareTwoStrings(string1,string2)*100).toFixed(0) + '%' : '0%';
    },
    disaggregationsSimilarity(array1,array2){
      let string1 = array1.join(' ');
      let string2 = array2.join(' ');
      return string1 && string2 ? (stringSimilarity.compareTwoStrings(string1,string2)*100).toFixed(0) + '%' : '0%';
    },
    valueDomainItemSimilarity(items1,items2){
      items1 =  items1.map(x=> x.code+x.name).join(' ');
      items2 =  items2.map(x=> x.code+x.name).join(' ');
      return items1 && items2 ? (stringSimilarity.compareTwoStrings(items1,items2)*100).toFixed(0) + '%' : '0%';
    },
    async alternativeSdsItemIdChanged(){
      this.form.alternative_sds_item_id = this.alternativeSdsItem.id
    },
    statusChanged(){
      if(!this.isRejected){
        this.alternativeSdsItem = null;
        this.rejectionNote.type = null;
        this.rejectionNote.note = null;
        this.form.alternative_sds_item_id =null;
      }
    },
    rejectSimilarItemsChecked(checked){
      if(checked){
        this.form.rejected_similiar_item_ids = this.setting.similar_submission.selected_ids;
      }else{
        this.form.rejected_similiar_item_ids =[]
      }
    }
  },
}
</script>
